/* tslint:disable */

/* DateTime in ISO 8601 format(&quot;yyyy-mm-ddThh:mm:ssZ&quot;).Ex. &quot;Wed, 11 Apr 2018 06:23:15 UTC +00:00&quot; when encoded to iso8601looks like &quot;2018-04-11T06:23:40Z&quot; */
export type DateTime = any

/* Date in ISO 8601 format (yyyy-mm-dd) */
export type Date = any

/* Unstructured data in JSON format */
export type JSONBlob = any

export type JSON = any

export interface Query {
  allAttachments: Attachment[] /* Get all attachments for the brand. \Only logged in users have access to the query.\Customer users can only access the brands they are related to,\Producers can only access brands they are managing (via BrandProducer model). */
  allBillingOrganisations: BillingOrganisation[] /* List all available billing organisations. */
  allBrandsForPurchase: Brand[] /* List all brands that a user can purchase for. */
  allBriefOptionGroups: BriefOptionGroup[] /* List all BriefOptionGroups */
  allContentManagerAssets?: ContentManagerAssetPaged | null /* Get all attachments for the brand. \Only logged in users have access to the query.\Customer users can only access the brands they are related to. */
  allContentManagerAttachments?: ContentManagerAttachmentPaged | null /* Get all attachments for the brand. \Only logged in users have access to the query.\Customer users can only access the brands they are related to. */
  allContentManagerCities: CityPaged /* Get all cities for the brand */
  allContentManagerProjects: ProjectPaged /* Get all projects for the brand */
  allCountries: Country[] /* List all available countries. */
  allCreators?: UsersPaged | null /* List creators */
  allCreditCards?: CreditCard[] | null /* Get all credit cards of current user and organisation */
  allCurrencies: Currency[] /* List all available currencies */
  allIndustries: Industry[] /* List all available industries. */
  allJobs?: JobsPaged | null /* Get all jobs assigned current user */
  allLanguages: Language[] /* List all available languages. */
  allOpportunities?: OpportunitiesPaged | null /* Get all opportunities belong to current user */
  allOrganisations: Brand[] /* List all available organisations. */
  allProducers: ProducersPaged /* List all producers that the user has access to. The default value for the endpoint are:&#x60;{activated: true, blocked: false }&#x60;.If &#x60;producerFilter&#x60; is not given, then the default values would be used; if it&#x27;s given with empty object, stillthe default value would be used.The default value would be overwritten with a explicit param */
  allProducts?: ProductsPaged | null /* Get all products */
  allProductsByBrand?: ProductsPaged | null /* Get all products by brand */
  allProductsByCategory?: ProductsPaged | null /* Get all products by marketplace category (old name marketplace product) */
  allProjects?: Project[] | null /* Get all projects for the current user */
  allProjectsPaginated?: ProjectsPaged | null /* Get paginated all projects for the current user */
  allPublishedWorkContracts?:
    | WorkContract[]
    | null /* Get all published work contracts that current user can apply for. */
  allRequestTicketTypes: RequestTicketType[] /* List all RequestTicketTypes */
  allRequestTickets: RequestTicketsPaged
  allServiceQualityLevels: ServiceQualityLevel[] /* List all available service quality levels */
  allSkills: Skill[] /* List all available creator skills */
  allTags: Tag[] /* List all industries that can be tagged into a video. */
  allTasksByHuman?: TasksPaged | null /* Get all tasks by human */
  allTasksByJob?: TasksPaged | null /* Get all tasks by job */
  allTimeProfiles: TimeProfile[] /* List all available time profiles */
  allVideoTypes: VideoType[] /* List all video types. */
  allWorkContractApplications?:
    | WorkContractApplication[]
    | null /* Get all work contract applications for current user. Defaults to pending and accepted only unless states are provided. */
  allWorkContractInvitations?:
    | WorkContractInvitation[]
    | null /* Get all work contract invitations for current user. Defaults to pending and accepted only unless states are provided. */
  calcProductCost: Price /* Get product cost (location independent) by uuid */
  calcProductCostForLocation: Price /* Get product cost in a given country and/or city by product uuid */
  checkEmail?: ExistenceResponse | null /* Check if User/Human email address exists */
  checkName?: ExistenceResponse | null /* Check if Brand/Organisation trading/billing name exists */
  checkWebsite?: ExistenceResponse | null /* Check if Brand/Organisation domain/website exists */
  configGetAllSections?: ConfigType | null /* Get list of all Sections */
  configGetSectionInfo?: ConfigType | null /* Get Section data, like list of the cards, possibly ordered */
  findCity: CitiesPaged /* Find city by search term */
  findCountryByIPAddress: Country /* Find country by ip address */
  getActivityFeed: FeedItemsPaged /* Get activity feed for the given object. \Only logged in users have access to the query. */
  getBillingCurrency: Currency /* Get the billing currency for a country */
  getBrandProfile?: Brand | null /* Get a brand profile. Only logged in users have acces to the query. */
  getBrandStats?: BrandStats | null /* Get a brands stats (e.g project/shoot/video/location counts) */
  getCharge: StripeCharge /* Get StripeCharge by ID */
  getComments: FeedCommentsPaged /* Get activity feed for the given object. \Only logged in users have access to the query. */
  getCreatorProfile: CreatorProfile /* Get a creator profile */
  getCurrentUser: User /* Get current user object */
  getEmailByResetPasswordToken: EmailByResetPasswordTokenResponse /* Get the users email using reset password token */
  getEvents: EventsPaged /* Get events for the given eventable object. \Only logged in users have access to the query. */
  getHyperwalletBalances?:
    | HyperwalletBalance[]
    | null /* Get Hyperwallet balances for current user */
  getJob: Job /* Get a job */
  getLinkedInProfile?: LinkedInProfile | null /* Get LinkedInProfile of a user for registration. */
  getLocalCurrency: Currency /* Get the local currency */
  getLocationProducts?: ProductsPaged | null /* Get all products available in a particular location */
  getMarketPlaceProduct: MarketplaceProduct /* Get marketplace product by slug */
  getMarketPlaceProducts?: MarketplaceProductsPaged | null /* Get products from the slug of a given tag */
  getNotifications: NotificationsPaged /* Get notifications for the given notifiable object or user. \Only logged in users have access to the query. */
  getOpportunity: Opportunity /* Get an opportunity */
  getProducerProfile: ProducerProfile /* Get producer profile.The query is accessible to Producer and Manager apps.Managers have access to any producer profile.Producers have access to theirs own profiles only. */
  getProduct: Product /* Get product by uuid */
  getProductLocations: ProductLocationsPaged /* Get all locations for a particular product */
  getProject: Project /* Get a video project */
  getQuoteForm: QuoteForm /* Return a quote based on input. When quote is null, the initial quote is given */
  getRequestAssignees?: RequestTicketAssignees | null /* Get list of humans to assign ad-hoc requests to them */
  getRequestTicket: RequestTicket
  getShoot: Shoot /* Get a shoot */
  getShortlist: WorkContractShortlist /* Get a work contract shortlist */
  getTranscodedAttachments: Attachment[] /* Get all attachments for the brand. \Only logged in users have access to the query.\Customer users can only access the brands they are related to. */
  getVideo: Video /* Get a video */
  getWorkContract: WorkContract /* Get a work contract */
  getWorkContractApplication: WorkContractApplication /* Get a work contract application */
  getWorkContractInvitation: WorkContractInvitation /* Get a work contract invitation */
  getYoutubeChannelProfile: YoutubeChannelProfile /* Fetch youtube channel info and videos */
  searchVideoById?: SearchableVideoResponse | null /* Search videos */
  searchVideos?: SearchableVideo[] | null /* Search videos */
  searchVideosByCategory?:
    | SimpleVideoLink[]
    | null /* Search videos by category (marketplace product) */
  validateNewBrand?: ValidationResponse | null /* Validate a new brand */
  validateNewUser?: ValidationResponse | null /* Validate a new user email */
  validateNewUserName?: ValidationResponse | null /* Validate a new user name */
  validatePassword?: PasswordValidationResponse | null /* Validate password strength */
}

export interface Attachment {
  approvalState?: ApprovableState | null
  assetType: AttachableType
  attachable: Attachable
  createdAt: DateTime
  downloadable?: boolean | null
  fileName?: string | null
  fileSize?: string | null
  fileType?: string | null
  fileUrl?: string | null
  id: string
  linkedProjects?: Project[] | null
  location?: Location | null
  metaData?: AttachmentMetaData | null
  project?: Project | null
  state: AttachmentState
  title?: string | null
  transcodedAttachments?: TranscodedAttachment[] | null
  type: AttachmentType
  updatedAt: DateTime
  uploader: User
  url?: string | null
  uuid: string
}
/* The brand object */
export interface Brand {
  [x: string]: any
  avatar?: CloudinaryImage | null
  createdAt: DateTime
  domain?: string | null
  id: string
  industries: Industry[]
  name: string
  permittedFeatures?: SubscriptionFeature[] | null
  preferredCreators?: User[] | null
  size?: BrandSize | null
  status: BrandStatus
  subscriptionLevel?: SubscriptionLevel | null
  tradingName: string
  usersCount: number
  uuid: string
  videoProjectsCount?: number | null
  website?: string | null
  mainPhone?: string | null
  city?: City | null
  country?: Country | null
  address?: string
  seoTitle?: string
  seoDescription?: string
  seoKeywords?: string
  facebookPage?: string
  twitterName?: string
  linkedinPage?: string
  youtubeName?: string
  functions?: BrandFunctions[]
  coolness?: BrandCoolness
  department?: BrandDepartment
  happiness?: BrandHappiness
  history?: BrandHistory
  parent?: Parent
  ultimateParent?: Parent
  regions?: Regions[]
  divisions?: Divisions[]
  division?: Divisions
  children?: Brand[]
  billingName?: string
  billingAddressCity?: string
  billingAddressCountry?: string
  billingAddressLine1?: string
  billingAddressLine2?: string
  billingAddressLine3?: string
  billingAddressPostCode?: string
  billingAddressType?: string
  payCycle?: PayCycle
  payCycleData?: PayCycleData
}

export interface PayCycleData {
  weekly: WeekDay
  monthly: number
  endOfMonth: number
  fromIssueDate: number
}
export interface Divisions {
  id: string
  name: string
  state: DivisionState
}
export interface Subbrands {
  id: string
  name: string
  state: DivisionState
}
export interface Regions {
  name?: string
}
export interface Parent {
  tradingName?: string | null
  uuid?: string | null
  divisions?: Divisions[]
  subbrands?: Subbrands[]
}
/* A cloudinary image */
export interface CloudinaryImage {
  cloudinaryId?: string | null
  cloudinaryType?: string | null
}
/* The Industry object. */
export interface Industry {
  name: string
  uuid: string
}
/* The user object */
export interface User {
  additionalEmails: string[]
  avatar?: CloudinaryImage | null
  confirmed?: boolean | null
  createdAt: DateTime
  dateOfBirth?: Date | null
  email: string
  facebookProfile?: string | null
  gender?: Gender | null
  id: string
  isBrand?: boolean | null
  isCreator?: boolean | null
  isProducer?: boolean | null
  linkedinProfile?: string | null
  locale?: string | null
  location?: Location | null
  lastVisitAt?: DateTime | null
  name?: string | null
  nickname?: string | null
  paymentInfo?: PaymentInfo | null
  phoneNumber?: string | null
  producerProfile?: ProducerProfile | null
  profilePageUrl: string
  ratingsPageUrl: string
  skypeUsername?: string | null
  timezone?: string | null
  twitterProfile?: string | null
  updatedAt: DateTime
  uuid: string
}
/* A geographic location */
export interface Location {
  address?: string | null
  city?: string | null
  country?: string | null
  countryCode?: string | null
  displayName?: string | null
  googlePlaceId?: string | null
  latitude?: number | null
  latitudeSpan: number[]
  longitude?: number | null
  longitudeSpan: number[]
  state?: string | null
}

export interface PaymentInfo {
  paypalAddress?: string | null
  salesTaxNumber?: string | null
}

export interface ProducerProfile {
  activated: boolean
  activeRequestTickets: RequestTicket[] /* Accessible to owner or manager.ASSIGNED tickets on top, then ACTIVE ones.Ordered by assigned_at date (the newest comes first). */
  blockedAt?: DateTime | null
  blockedBy?: User | null
  createdAt?: DateTime | null
  languages: Language[]
  online: boolean
  requestTicketTypes: RequestTicketType[]
  scheduledRequestTickets: RequestTicket[] /* Accessible to owner or manager. Ordered by scheduled_for date. */
  serviceQualityLevel?: ServiceQualityLevel | null
  status: ProducerStatus
  user: User
}

export interface RequestTicket {
  actionTargetName?:
    | string
    | null /* Contains a user name for Call type request, or Video/Shoot name for Update type request */
  assignedAt?: DateTime | null
  assignee?: RequestTicketAssignee | null /* This is null when Gen1 request fails. */
  assigneeType: RequestTicketAssigneeType
  billingOrganisation?: BillingOrganisation | null
  brandUuid?: string | null
  comments?: Comment[] | null
  commentsCount?: number | null
  coordinates?: Coordinates | null
  createdAt?: DateTime | null
  details?: JSONBlob | null
  language?: RequestTicketLanguage | null
  linkable?: RequestTicketLinkable | null /* Job or Task the ticket is linked to */
  matchedReason?: RequestTicketMatchedReason | null
  moderationApprovedAt?: DateTime | null
  moderationClaimedAt?: DateTime | null
  moderationDroppedAt?: DateTime | null
  moderationRejectedAt?: DateTime | null
  moderator?: RequestTicketModerator | null /* This is null when Gen1 request fails. */
  parent?: RequestTicket | null /* Parent request ticket */
  preferredAssigneeEmails: string[] /* Deprecated: use preferredAssigneeUuids instead */
  preferredAssigneeUuids: string[]
  preferredCurrentUser?:
    | boolean
    | null /* Only accessible to the assignee. Use this field to tell if the requester listed the current_user as one of the preferred assignees. */
  reassignAt?: DateTime | null
  requestTicketType: RequestTicketType
  requester?: RequestTicketRequester | null /* This is null when Gen1 request fails. */
  requesterType: RequestTicketRequesterType
  resolvedAt?: DateTime | null
  scheduledFor?: DateTime | null
  state: RequestTicketState
  target?: RequestTicketTarget | null /* This is null either because there is no target, or because Gen1 request fails. */
  unreadCommentsCount?:
    | number
    | null /* Number of unread comment notifications for the current user about this RequestTicket */
  urgency: RequestTicketUrgency
  uuid: string
  workedBeforeAssigneeUuids: string[]
}

export interface CreatorProfile {
  activationCall?: DateTime | null
  activeWorkflowRequests?: WorkflowRequest[] | null
  billingCurrency: Currency
  bio?: string | null
  clients: Client[]
  createServices: CreateService[]
  creatorReference?: CreatorReference | null
  equipments: Equipment[]
  industries: Industry[]
  languages: Language[]
  onboardedAt?: DateTime | null
  personalVideo?: Asset | null
  scheduledWorkflowRequests?: WorkflowRequest[] | null
  state?: CreatorProfileState | null
  user?: User | null
  workExamples: Asset[]
}

export interface WorkflowRequest {
  dueDate?: DateTime | null
  name?: string | null
  state: WorkflowRequestState
  target: RequestTicketTarget
  url?: string | null
}

export interface Project {
  attachments: Attachment[]
  audience?: string | null
  baseTemplate?: VideoProjectTemplate | null /* Base template for selected Product */
  brand?: Brand | null
  briefCompleted?: boolean | null
  briefOptions?: BriefOption[] | null
  budget?: Price | null
  canChargeToAccount?: boolean | null /* Check if this VideoProject can be charged to account */
  createdAt: DateTime
  creatorTeam?: User[] | null
  currencyConverter?: Price | null /* Budget converted from base template currency to brand currency */
  customerContract: CustomerContract
  description?: string | null
  dueDate?: DateTime | null
  inspirations?: string[] | null /* Videos we like */
  jobs?: Job[] | null
  landingUrl?:
    | string
    | null /* URL that the user should land at for this project. Returns &#x60;nil&#x60; if project do not have a shoot */
  location?: Location | null
  locationMultiplier?: LocationMultiplier | null /* Price and cost based on user location */
  name: string
  orderClaimed?: boolean | null
  price?: Price | null
  product?: Product | null
  productSpec?: JSONBlob | null /* Field that contains product specification data */
  projectLevel?: ProjectLevel | null
  quoteAccepted?: boolean | null
  quoteCompleted?: boolean | null
  relationships?: Relationship[] | null
  requestCompleted?: boolean | null
  salesCampaign?: string | null
  salesChannel?: string | null
  salesMedium?: string | null
  salesReferrer?: string | null
  salesSource?: string | null
  shoots?: Shoot[] | null
  state: ProjectState
  thumbnailUrl?: string | null
  url: string /* URL to the video project */
  uuid: string
  videos?: Video[] | null
  workContracts?: WorkContract[] | null
  workflowState?: string | null
}
/* Templates that are displayed to the brands for them to use as a starting point when creating an order. */
export interface VideoProjectTemplate {
  city?: City | null
  country?: Country | null
  image?: CloudinaryImage | null
  jobTemplatePackages: JobTemplatePackage[]
  name: string
  slug: string
  type: VideoProjectTemplateType
}

export interface City {
  country: Country
  default: boolean
  lat?: number | null
  long?: number | null
  name: string
  subdivision1Code?: string | null
  subdivision1Name?: string | null
  subdivision2Code?: string | null
  subdivision2Name?: string | null
  timezone: string
  uuid: string
}

export interface Country {
  cities?: City[] | null
  code: string
  currencyCode: string
  currencySymbol: string
  name: string
  primary: boolean
  timezone: string
  uuid: string
}

export interface JobTemplatePackage {
  description: string
  icon?: CloudinaryImage | null
  jobTemplates: JobTemplate[]
  name: string
  serviceType?: ServiceType | null
  slug: string
  uuid: string
}

export interface JobTemplate {
  name: string
  skill: Skill
  slug: string
  type: JobTemplateType
}

export interface Skill {
  backgroundImage?: CloudinaryImage | null
  basePrice: Price /* If currencyCode is not provided it will default to USD */
  basePriceUsd?: number | null
  description?: string | null
  foregroundImage?: CloudinaryImage | null
  name?: string | null
  serviceQualityLevelRates?:
    | ServiceQualityLevelRate[]
    | null /* Hourly rates for the current user for each service quality level based on the user&#x27;s location.If a currencyCode is not provided then it will be in the currency for the user&#x27;s country. */
  slug?: string | null
}
/* Total price */
export interface Price {
  amount: number
  currency: Currency
}
/* The currency object. */
export interface Currency {
  code: string
  default: boolean
  denomination: number
  name: string
  position: CurrencyPositionEnum
  symbol: string
}

export interface ServiceQualityLevelRate {
  price: Price
  serviceQualityLevel: ServiceQualityLevel
}

export interface ServiceQualityLevel {
  icon?: CloudinaryImage | null
  multiplier?: number | null
  name?: string | null
  slug: string
}

export interface BriefOption {
  briefOptionGroup: BriefOptionGroup
  createdAt: DateTime
  icon: string
  id: string
  name: string
  position?: number | null
  slug?: string | null
}

export interface BriefOptionGroup {
  briefOptions?: BriefOption[] | null
  createdAt: DateTime
  id: string
  name: string
  position?: number | null
  slug?: string | null
}

export interface CustomerContract {
  brandToInvoice: Brand
  controllingCompany: Brand
  createdAt: DateTime
  currencyCode?: string | null
  currencySymbol?: string | null
  description?: string | null
  invoices?: CustomerContractInvoice[] | null
  lostReason?: string | null
  projects?: Project[] | null
  proposalState?: string | null
  signingDate?: DateTime | null
  signedAt?: DateTime | null
  state?: string | null
  uuid: string
}

export interface CustomerContractInvoice {
  amountPaid?: Price | null
  createdAt: DateTime
  customerContract: CustomerContract
  description: string
  discount?: number | null
  discountAmount?: Price | null
  dueDate?: DateTime | null
  dueDateConfirmedAt?: DateTime | null
  expectedDate?: DateTime | null
  expectedDateConfirmedAt?: DateTime | null
  fullyPaid?: boolean | null
  fullyPaidOnDate?: DateTime | null
  invoiceType: string
  issueDate?: DateTime | null
  price: Price
  priceWithDiscount: Price
  tax?: Price | null
  total?: Price | null
  uuid: string
}

export interface Job {
  completable?: boolean | null
  completedTaskCount?: number | null
  createdAt: DateTime
  creator?: User | null
  description?: string | null
  dueDate?: DateTime | null
  hours?: number | null
  id: number
  location?: Location | null
  name: string
  producer?: User | null
  producerName?: string | null
  project: Project
  serviceQualityLevel?: ServiceQualityLevel | null
  shortName?: string | null
  skill?: Skill | null
  startDate?: DateTime | null
  startable?: boolean | null
  startedAt?: DateTime | null
  state: JobState
  tasksCompleted?: boolean | null
  timeProfile?: TimeProfile | null
  totalCost?: Price | null
  totalPrice?: Price | null
  totalTaskCount?: number | null
  uuid: string
  workContract?: WorkContract | null
}

export interface TimeProfile {
  hours?: number | null
  icon?: CloudinaryImage | null
  multiplier?: number | null
  name?: string | null
  shootHours?: number | null
  slug: string
}

export interface WorkContract {
  amountPaid?: Price | null
  applications?: WorkContractApplication[] | null
  completedAt?: DateTime | null
  createdAt: DateTime
  creator?: User | null
  description?: string | null
  fullyPaid?: boolean | null
  fullyPaidOnDate?: DateTime | null
  id: number
  invitations?: WorkContractInvitation[] | null
  jobs?: Job[] | null
  name: string
  project: Project
  published?: boolean | null
  state: WorkContractState
  totalCost?: Price | null
  totalPrice?: Price | null
  uuid: string
}

export interface WorkContractApplication {
  createdAt: DateTime
  creator: User
  state: WorkContractApplicationState
  uuid: string
  workContract: WorkContract
}

export interface WorkContractInvitation {
  createdAt: DateTime
  creator: User
  inviter: User
  state: WorkContractInvitationState
  uuid: string
  workContract: WorkContract
}

export interface LocationMultiplier {
  costMultiplier?: number | null
  priceMultiplier?: number | null
}

export interface Product {
  activationState: ProductActivationStateType
  description: string
  image?: CloudinaryImage | null
  language: Language
  marketingSpecs?: JSONBlob | null
  marketplaceProduct: MarketplaceProduct
  name: string
  productSpecs?: JSONBlob | null
  productionSpec?: JSONBlob | null
  uuid: string
  videoProjectTemplate: VideoProjectTemplate
}

export interface Language {
  name: string
  uuid: string
}
/* Product for marketplace */
export interface MarketplaceProduct {
  averagePrice?: Price | null
  city?: City | null
  country?: Country | null
  description: string
  image?: CloudinaryImage | null
  industries: Industry[]
  isActive?: boolean | null
  linkTo: string
  name: string
  productMarketing?: JSONBlob | null
  productSpecs?: JSONBlob | null
  promo?: string | null
  rating?: MarketplaceRating | null
  relatedProducts: MarketplaceProduct[]
  skills: Skill[]
  slug: string
  tags: MarketplaceTag[]
  uuid: string
  videoProjectTemplate?: VideoProjectTemplate | null
}
/* Rating for a Marketplace product */
export interface MarketplaceRating {
  average: number
  count: number
}
/* Tag object for a marketplace product */
export interface MarketplaceTag {
  name: string
  slug: string
}

export interface Relationship {
  createdAt: DateTime
  function: string
  id: string
  organisation: Brand
  primary: boolean
  roles?: Role[] | null
}

export interface Role {
  createdAt: DateTime
  id: string
  roleType: string
  roleTypeLabel: string
  user: User
}

export interface Shoot {
  attachments: Attachment[]
  brief?: string | null
  createdAt: DateTime
  jobs?: Job[] | null
  location?: Location | null
  name: string
  position: number
  project: Project
  shootFootages: ShootFootage[]
  shootHours?: number | null
  shootTime?: DateTime | null
  thumbnailUrl?: string | null
  uuid: string
  workflow_color: string
  workflow_state: ShootWorkflowState
}
/* Shoot Footage. */
export interface ShootFootage {
  attachments: Attachment[]
  label: string
  uuid: string
}

export interface Video {
  approvalState?: ApprovableState | null
  attachments: Attachment[]
  audience?: string | null
  brief?: string | null
  createdAt: DateTime
  description?: string | null
  jobs?: Job[] | null
  location?: Location | null
  name: string
  project: Project
  thumbnailUrl?: string | null
  uuid: string
  workflowColor: string
  workflowState: VideoWorkflowState
}

export interface Client {
  name: string
  uuid: string
}
/* The service offered by a creator */
export interface CreateService {
  activatedServiceQualityLevel?: ServiceQualityLevel | null
  activationType?: CreateServiceActivationType | null
  createServiceQualityLevels: CreateServiceQualityLevel[]
  rateComment?: string | null
  rejectionComment?: string | null
  rejectionReason?: CreateServiceRejectionReason | null
  serviceQualityLevels: ServiceQualityLevel[]
  skill?: Skill | null
  state?: CreateServiceState | null
  timeProfiles: TimeProfile[]
  uuid: string
  workExamples: Asset[]
}
/* CreateServiceQualityLevel */
export interface CreateServiceQualityLevel {
  serviceQualityLevel: ServiceQualityLevel
  state: CreateServiceState
}

export interface Asset {
  content?: Content | null
  contentType?: AssetContentType | null
  description?: string | null
  originator?: string | null
  previousVersions: Asset[]
  previousVersionsCount?: number | null
  title?: string | null
  type?: AssetType | null
  uuid: string
}

export interface GCSAttachment {
  fileName?: string | null
  fileSize?: string | null
  mimeType?:
    | string
    | null /* Mime type of content e.g &#x27;video/mp4&#x27;, &#x27;image/jpeg&#x27; */
  putLocationUrl?:
    | string
    | null /* URL that client can straight away PUT file contents to upload. Web clients can use this to avoid CORS issues.The server is the one initiating the resumable upload with a POST to Google Storage, and returns the Location header of the response.The downside to this is that client may not be sending uploads from the same GS region that the server initiated the upload.Returns nil if the attachment has already been uploaded. */
  uploadUrl?:
    | string
    | null /* Clients perform resumable upload on this URL.Start uploading with POST, then PUT content to the returned Location header:curl -X POST -H &#x27;content-type: &lt;content type&gt;&#x27; -H &#x27;content-length: 0&#x27;       -H &#x27;x-goog-resumable: start&#x27; &#x27;&lt;uploadURL&gt;&#x27;A signed upload URL (for making initial POST) expires after 5 minutes,but the exchanged Location URL (for PUT&#x27;ing data) expires after a weekSee https://goo.gl/4thnN9Follow Reccommended Practice at https://goo.gl/Epc4sR */
  uploadedAt?: DateTime | null
  url?: string | null
  uuid: string
}

export interface ExternalLink {
  channel?:
    | string
    | null /* One of &#x27;youtube&#x27;, &#x27;vimeo&#x27;, &#x27;website&#x27; or &#x27;other&#x27;. */
  url?: string | null
}

export interface CreatorReference {
  email?: string | null
  name?: string | null
}

export interface Equipment {
  category: EquipmentCategory
  name: string
  uuid: string
}
/* The billing organisation object */
export interface BillingOrganisation {
  name: string
  uuid: string
}

export interface Comment {
  body?: string | null
  commentable: Commentable
  commenter: User
  createdAt: DateTime
  type: CommentType
  updatedAt: DateTime
  uuid: string
}

export interface Campaign {
  city: City
  consultant: User
  country: Country
  createdAt?: DateTime | null
  description: string
  endDate?: DateTime | null
  name: string
  startDate?: DateTime | null
  type: CampaignType
  updatedAt?: DateTime | null
  url?: string | null
  uuid: string
}

export interface CampaignType {
  campaigns?: Campaign[] | null
  createdAt?: DateTime | null
  name: string
  updatedAt?: DateTime | null
  uuid: string
}

export interface ContentChannel {
  brand: Brand
  contentGroups?: ContentGroup[] | null
  createdAt?: DateTime | null
  description: string
  imageLarge: string
  imageSmall: string
  name: string
  position: number
  summary: string
  type: ContentChannelType
  updatedAt?: DateTime | null
  uuid: string
}

export interface ContentGroup {
  brand: Brand
  contentChannel?: ContentChannel | null
  createdAt?: DateTime | null
  description: string
  endDate?: DateTime | null
  frequencyInDays: number
  human?: User | null
  imageLarge: string
  imageSmall: string
  name: string
  numberOfVideos: number
  position: number
  startDate?: DateTime | null
  summary: string
  type: ContentGroupType
  updatedAt?: DateTime | null
  uuid: string
}
/* Latitude and Longitude */
export interface Coordinates {
  latitude: number
  longitude: number
}

export interface Task {
  description?: string | null
  isCompleted?: boolean | null
  name?: string | null
  overridable?: boolean | null
  position?: number | null
  scripted?: boolean | null
  uuid: string
  validated?: boolean | null
}

export interface RequestTicketType {
  category?: string | null
  icon?: CloudinaryImage | null
  requestType: string
  subcategory?: string | null
  subtext?: string | null
  title?: string | null
  uuid: string
}

export interface Gen1Bot {
  avatar?: CloudinaryImage | null
  name?: string | null
}

export interface AttachmentMetaData {
  height?: number | null
  resolution?: number | null
  width?: number | null
}

export interface TranscodedAttachment {
  thumbnails?: Attachment[] | null
  transcodedAttachment?: Attachment | null
}
/* Paginated view of the content manager assets */
export interface ContentManagerAssetPaged {
  assets: ContentManagerAsset[]
  pageInfo: PageInfo
}

export interface ContentManagerAsset {
  assetExternalUrl?: string | null
  assetFileSize?: number | null
  assetFileType?: string | null
  assetFileUrl?: string | null
  assetFileUuid?: string | null
  assetId?: string | null
  assetName?: string | null
  assetThumbnailUrl?: string | null
  assetType?: ContentManagerAssetType | null
  assetUuid?: string | null
  assetVaasUrl?: string | null
  cityName?: string | null
  cityUuid?: string | null
  createdAt?: DateTime | null
  projectName?: string | null
  projectUuid?: string | null
  updatedAt?: DateTime | null
}
/* Page information */
export interface PageInfo {
  currentPage: number
  lastPage: boolean
  totalCount: number
}
/* Paginated view of the content manager attachments */
export interface ContentManagerAttachmentPaged {
  attachments: ContentManagerAttachment[]
  pageInfo: PageInfo
}

export interface ContentManagerAttachment {
  assetType: AttachableType
  cityName?: string | null
  cityUuid?: string | null
  createdAt: DateTime
  fileName?: string | null
  fileSize?: string | null
  fileType?: string | null
  fileUrl?: string | null
  id: string
  state: AttachmentState
  thumbnailUrl?: string | null
  title?: string | null
  transcodedThumbnailUrl?: string | null
  type: AttachmentType
  updatedAt: DateTime
  url?: string | null
  uuid: string
  videoProjectName?: string | null
  videoProjectUuid?: string | null
}

export interface CityPaged {
  cities: City[]
  pageInfo: PageInfo
}

export interface ProjectPaged {
  pageInfo: PageInfo
  projects: Project[]
}

export interface UsersPaged {
  pageInfo?: PageInfo | null
  users: User[]
}
/* The CreditCard object */
export interface CreditCard {
  brand: Brand
  cardBrand: string
  cardFunding: string
  createdAt: DateTime
  expiryMonth: number
  expiryYear: number
  id: string
  last4Digits: string
  owner: User /* The human who added card */
  permission: string
  updatedAt: DateTime
}

export interface JobsPaged {
  jobs: Job[]
  pageInfo?: PageInfo | null
}

export interface OpportunitiesPaged {
  opportunities: Opportunity[]
  pageInfo?: PageInfo | null
}

export interface Opportunity {
  actionSlug?: string | null
  convertedAt?: DateTime | null
  createdAt?: DateTime | null
  currencyCode?: string | null
  inProgressAt?: DateTime | null
  lostAt?: DateTime | null
  name?: string | null
  opportunity_type?: OpportunityType | null
  organisation: Brand
  preferredProducerOnly?: boolean | null
  priority: OpportunityPriority
  requester?: User | null
  salesforceId?: string | null
  sourceType: OpportunitySourceType
  state: OpportunityState
  uuid: string
  value: number
}

export interface OpportunityType {
  actionSlug?: string | null
  assigneeType?: number | null
  iconUrl?: string | null
  id: string
  instruction?: string | null
  opportunities?: Opportunity[] | null
  targetType?: number | null
  title?: string | null
  type?: number | null
}

export interface ProducersPaged {
  pageInfo: PageInfo
  producers: ProducerProfile[]
}
/* Paginated view of the products */
export interface ProductsPaged {
  pageInfo: PageInfo
  products: Product[]
}
/* Paginated view of the projects */
export interface ProjectsPaged {
  pageInfo: PageInfo
  projects: Project[]
}

export interface RequestTicketsPaged {
  pageInfo: PageInfo
  requestTickets: RequestTicket[]
}
/* The tag object. This is used for tagging industry to a video project. */
export interface Tag {
  id: number
  name: string
}
/* Paginated view of the tasks */
export interface TasksPaged {
  pageInfo: PageInfo
  tasks: Task[]
}
/* The video type object. Indicating what is the type of the video (case studies, interviews). */
export interface VideoType {
  description?: string | null
  id: number
  name: string
  position: number
  slug: string
}
/* A response about existence */
export interface ExistenceResponse {
  exist: boolean
}

export interface ConfigType {
  sections?: string[] | null
  uuids?: string[] | null
}

export interface CitiesPaged {
  cities: City[]
  pageInfo: PageInfo
}
/* Paginated view of the feed items */
export interface FeedItemsPaged {
  items: FeedItem[]
  pageInfo: PageInfo
}
/* Feed item from the activity feed. */
export interface FeedItem {
  createdAt: DateTime
  feedable: Feedable
  id: string
  itemable: FeedItemable
  updatedAt: DateTime
}

export interface Issue {
  acceptedAt?: DateTime | null
  brand: Brand
  createdAt?: DateTime | null
  escalatedAt?: DateTime | null
  inProgressAt?: DateTime | null
  inReviewAt?: DateTime | null
  notResolvedAt?: DateTime | null
  note?: string | null
  project: Project
  rating?: number | null
  resolvedAt?: DateTime | null
  state: IssueState
  submitter: User
  updatedAt?: DateTime | null
  uuid: string
}

export interface FeedComment {
  body: string
  children?: FeedComment[] | null
  commentable: Commentable
  commenter: User
  createdAt: DateTime
  event?: Event | null
  parent?: FeedComment | null
  submitter: User
  type: FeedCommentType
  updatedAt: DateTime
  uuid: string
}

export interface Event {
  createdAt: DateTime
  data: string
  eventable: Eventable
  jobs?: Job[] | null
  submitter?: User | null
  type: string
  updatedAt: DateTime
  uuid: string
}
/* The stats for a brand */
export interface BrandStats {
  locationCount: number /* The amount of unique locations this brand has shoots in (excluding ones on lost projects) */
  projectCount: number /* The amount of projects this brand has (excluding lost projects) */
  publishedVideoCount: number /* The amount of published videos this brand has (excluding ones on lost projects) */
  shootCount: number /* The amount of shoots this brand has (excluding ones on lost projects) */
  videoCount: number /* The amount of videos this brand has (excluding ones on lost projects) */
}
/* The StripeCharge object */
export interface StripeCharge {
  amount: number
  createdAt: DateTime
  currencyCode: string
  error?: string | null
  id: string
  status: StripeChargeStatus
  updatedAt: DateTime
}
/* Paginated view of the comments */
export interface FeedCommentsPaged {
  comments: FeedComment[]
  pageInfo: PageInfo
}

export interface EmailByResetPasswordTokenResponse {
  email: string
}
/* Paginated view of the events */
export interface EventsPaged {
  events: Event[]
  pageInfo: PageInfo
}

export interface HyperwalletBalance {
  amount: number
  currency: string
}

export interface LinkedInProfile {
  accessToken: string
  avatar?: CloudinaryImage | null
  currentCompanyName?: string | null
  email: string
  name: string
}
/* Paginated view of the marketplace products */
export interface MarketplaceProductsPaged {
  pageInfo: PageInfo
  products: MarketplaceProduct[]
}

export interface NotificationsPaged {
  notifications: Notification[]
  pageInfo: PageInfo
}

export interface Notification {
  action: NotificationAction
  actor?: User | null
  createdAt: DateTime
  data?: string | null
  notifiable?: Notifiable | null
  readAt: DateTime
  recipient?: User | null
  updatedAt: DateTime
  uuid: string
}
/* Paginated view of the product locations */
export interface ProductLocationsPaged {
  pageInfo: PageInfo
  productLocations: ProductLocation[]
}

export interface ProductLocation {
  city?: City | null
  country?: Country | null
  product: Product
}
/* Contains necessary data to render the Simple Purchase form */
export interface QuoteForm {
  jobTemplatePackages: QuotedJobTemplatePackage[] /* Job Template Packages scoped to the selected VideoProjectTemplate(in quote object) */
  masterServiceQualityLevelsPriced: ServiceQualityLevelPriced[] /* ServiceQualityLevel options.Price here is the sum of all jobs at respective SQL, for the current quoted jobs */
  masterTimeProfilesPriced: TimeProfilePriced[] /* TimeProfile options.Price here is the selected SQL price(in quote object) mutiplied by the number of hours */
  quote: Quote /* The current &quot;selected&quot; configuration */
  trackingUuid: string /* When a user starts a new shoot anywhere, generated this UUID to keep trackuser action before it is turned into a project. */
  videoProjectTemplateType: VideoProjectTemplateType
  videoProjectTemplates: VideoProjectTemplate[] /* VideoProjectTemplate options. One for each location */
}
/* This is just a JobTemplatePackage with a ServiceQualityLevel and TimeProfile selected, and a price */
export interface QuotedJobTemplatePackage {
  index: number /* Index of this item in a list */
  jobTemplatePackage: JobTemplatePackage
  price: Price
  quotedHours: number /* The actual number of hours quoted.This might be different from values of the related TimeProfileif the serviceType is producer, for example */
  serviceQualityLevel: ServiceQualityLevel
  timeProfile: TimeProfile
}

export interface ServiceQualityLevelPriced {
  price: Price
  serviceQualityLevel: ServiceQualityLevel
}

export interface TimeProfilePriced {
  price: Price
  timeProfile: TimeProfile
}

export interface Quote {
  baseTemplate?: VideoProjectTemplate | null /* Base template for selected Product */
  currencyConverter?: Price | null /* Budget converted from base template currency to brand currency */
  editDueAt?: DateTime | null
  email?: string | null /* Email passed into the quote, null when nothing passed in */
  inspirationVideoUrls: string[]
  locationMultiplier?: LocationMultiplier | null /* Price and cost based on user location */
  overview?: string | null
  price: Price /* Sum of all projectServices&#x27; price */
  productSpec?: JSONBlob | null /* Field that contains product specification data */
  productUuid?: string | null
  projectDueAt?: DateTime | null
  selectedJobTemplatePackages: QuotedJobTemplatePackage[]
  selectedMasterServiceQualityLevel: ServiceQualityLevel
  selectedMasterTimeProfile: TimeProfile
  shootStartAt?: DateTime | null
  title: string /* Default to English, &quot;New Shoot - Singapore&quot; */
  videoProjectTemplate: VideoProjectTemplate
}

export interface RequestTicketAssignees {
  RequestTicketAssignees: RequestTicketAssignee[]
  count: number
}

export interface WorkContractShortlist {
  createdAt: DateTime
  human: User
  updatedAt: DateTime
  uuid: string
  workContract: WorkContract
}

export interface YoutubeChannelProfile {
  avatar?: string | null
  channelId?: string | null
  email?: string | null
  gender?: string | null
  locale?: string | null
  name?: string | null
  profileUrl?: string | null
  videoUrls: string[]
}

export interface SearchableVideoResponse {
  adwordsData: SearchableAdwordVideo[]
  performanceSuggestionsData: PerformanceSuggestion[]
  videoIntelligenceData: SearchableVideo[]
  youtubeReportData: YoutubeReport[]
  youtubeRetentionData: YoutubeRetention[]
}

export interface SearchableAdwordVideo {
  averageCpv?: number | null
  clicks?: number | null
  conversions?: number | null
  cost?: number | null
  ctr?: number | null
  customerId?: number | null
  date?: string | null
  device?: string | null
  impressions?: number | null
  videoDurationInMiliseconds?: number | null
  videoQuartile100Rate?: number | null
  videoQuartile25Rate?: number | null
  videoQuartile50Rate?: number | null
  videoQuartile75Rate?: number | null
  videoViewRate?: number | null
  videoViews?: number | null
  youtubeVideoId: string
}

export interface PerformanceSuggestion {
  action: string
  category: string
  fact: string
  score: number
}

export interface SearchableVideo {
  brandName: string
  brandType?: string | null
  industries?: string[] | null
  innerHits: Entity[]
  projectCompletedDate: string
  projectId: number
  projectName: string
  projectPriceUsd: number
  projectRatingOverall: number
  projectUrl: string
  shootCountries?: string[] | null
  shots: Shot[]
  videoId: number
  videoType?: string | null
  youtubeUrl?: string | null
}

export interface Entity {
  confidence: number
  description: string
  shots: Shot[]
  videoPercentage: number
}

export interface Shot {
  endTime: number
  startTime: number
}

export interface YoutubeReport {
  action: number
  annotationClosableImpressions: number
  annotationCloseRate: number
  annotationCloses: number
  annotationImpressions: number
  averageViewDurationPercentage: number
  averageViewDurationSeconds: number
  cardClickRate: number
  cardClicks: number
  cardImpressions: number
  cardTeaserClickRate: number
  cardTeaserClicks: number
  cardTeaserImpressions: number
  category: number
  channelId: number
  comments: number
  countryCode: string
  date: string
  dislikes: number
  fact: number
  likes: number
  liveOrOnDemand: string
  redViews: number
  redWatchTimeMinutes: number
  reportId: number
  shares: number
  subscribedStatus: string
  subscribersGained: number
  subscribersLost: number
  videosAddedToPlaylists: number
  videosRemovedFromPlaylists: number
  views: number
  watchTimeMinutes: number
  youtubeVideoId: string
}

export interface YoutubeRetention {
  audienceWatchRatio: number
  elapsedVideoTimeRatio: number
  endDate: string
  relativeRetentionPerformance: number
  startDate: string
}

export interface SimpleVideoLink {
  channelHost?: string | null
  createdAt: DateTime
  state?: string | null
  thumbnailUrl?: string | null
  updatedAt: DateTime
  url: string
  video: SimpleVideo
}

export interface SimpleVideo {
  description?: string | null
  id: number
  name: string
}
/* Validation Response */
export interface ValidationResponse {
  errors: AttributeError[]
  valid?: boolean | null
}

export interface AttributeError {
  code?: string | null
  extra?: AttributeErrorExtra[] | null
  field?: string | null
  model?: string | null
}

export interface AttributeErrorExtra {
  key?: string | null
  value?: string | null
}
/* Password validation response */
export interface PasswordValidationResponse {
  maxPasswordLength: number
  minPasswordLength: number
  minPasswordScore: number
  passwordLength: number
  passwordScore: number
  passwordSuggestions: string[]
  passwordValid: boolean
  passwordWarning?: string | null
}

export interface Mutation {
  acceptWorkContractInvitation?: SuccessResponse | null /* Accept a gig (work contract) */
  addAnalyticOrder?: SuccessResponse | null /* Store information about source of the project */
  addAsset?: Asset | null
  addComment?: Comment | null /* Add a comment on a commentable record. */
  addCreatorClient?: Client | null /* Add a Creator Client */
  addCreatorCreateService?: CreateService | null /* Add a create service to a creator_profile */
  addCreatorEquipment?: Equipment | null /* Add equipment to creator profile */
  addCreditCard?: CreditCard | null /* Add a credit card */
  addDevice?: SuccessResponse | null /* Add a mobile device for the current user */
  addVideoPlatformIntegration?: SuccessResponse | null /* Link a third party video platform integration to the user */
  analyticsRegisterEvent?: SuccessResponse | null /* Store information about Specific eventsdescribing how user is interacting with an interface */
  applyForWorkContract?: SuccessResponse | null /* Apply for a gig (work contract) */
  cancelRequestTicket?: SuccessResponse | null /* Cancel a RequestTicket that is currently in state UNASSIGNED, ASSIGNED, SCHEDULED or ACTIVE.Returns { success: false } if state is wrong. */
  changePassword?: SuccessResponse | null /* Allow a user to change his/her password. */
  claimRequestTicket?: RequestTicket | null /* Claim a RequestTicket that is currently in state ASSIGNED. */
  completeCreatorProfileActivation?: CreatorProfile | null /* Move a CreatorProfile from activation to completed stage. Should be called by a manager */
  completeCreatorProfileInfo?: CreatorProfile | null /* Move a CreatorProfile from profile to skills stage */
  completeCreatorProfileSkills?: CreatorProfile | null /* Move a CreatorProfile from skills to activation stage */
  completeJob?: SuccessResponse | null /* Complete a job */
  confirmEmailAndLogin?: AuthResponse | null /* Confirm email with a unique confirmation token and return JWT upon successful request. */
  createAttachment?: Attachment | null
  createCustomProject?: Project | null /* Creates a video project for a brand where you can cherry pick which jobs you want to \add into the project. This is for the original self drive checkout process. */
  createInvitation: WorkContractInvitation /* Create Work Contract Invitation */
  createMarketplaceProduct?: MarketplaceProduct | null
  createOpportunity?: Opportunity | null /* Create an opportunity */
  createOpportunityProducerProfile?: OpportunityProducerProfile | null /* Create an opportunity producer profile */
  createProject?: Project | null /* Creates a video project for a brand based on product spec. */
  createProjectVariation?: Project | null /* Add a variation based on existing project */
  createRequestTicket?: RequestTicket | null /* Create a RequestTicket */
  customerAcceptPurchase?: SuccessResponse | null /* Customer accept purchase */
  declineRequestTicket?: SuccessResponse | null /* Decline a RequestTicket that is currently in state ASSIGNED.Returns { success: false } if state is wrong. */
  declineWorkContractInvitation?: SuccessResponse | null /* Decline a gig (work contract) */
  deleteAsset?: SuccessResponse | null
  deleteComment?: SuccessResponse | null
  deleteCreatorClient?: SuccessResponse | null /* Remove a Creator Client */
  deleteCreatorCreateService?: SuccessResponse | null /* Delete a create service from a creator_profile */
  deleteCreatorEquipment?: SuccessResponse | null /* Delete equipment from creator profile */
  deleteCreditCard?: SuccessResponse | null /* Delete a credit card */
  deleteInvitation?: SuccessResponse | null /* Remove a Work Contract Invitation */
  deleteMarketplaceProduct?: SuccessResponse | null /* Remove a Marketplace Product */
  deleteShortlist?: SuccessResponse | null /* Deletes given work contract shortlist. */
  editComment?: SuccessResponse | null
  forgotPassword?: SuccessResponse | null /* Allow users to trigger the password recovery email sent to his/her email address. */
  getAccessToken?: AuthTokensResponse | null /* Get access token based on refresh token */
  linkAttachment?: SuccessResponse | null
  lockAppUser?: SuccessResponse | null /* Lock an app user. */
  loginEmail?: AuthResponse | null /* Authenticate the given email/password and return a JWT that keeps user&#x27;s session. */
  loginJwtCookie?: AuthResponse | null /* Authenticate the user with given cookies */
  loginManagerWithGoogleAuth?: SocialRegistrationResponse | null /* Register/Login manager with google auth token, accessible to manager app only */
  loginSocialAuth?: AuthResponse | null /* Authenticate the given social identity and return a JWT that keeps user&#x27;s session. */
  logoutDevice?: SuccessResponse | null /* Logout a mobile device for the current user.Server will stop pushing notifications to the specified device. */
  markRequestTicketNotificationsRead?: RequestTicket | null /* Mark all notifications on a RequestTicket as read */
  moderationApproveRequestTicket?: RequestTicket | null /* Moderator approves a RequestTicketUpdate RequestTicket state from MODERATION_CLAIMED to MODERATION_APPROVED */
  moderationClaimRequestTicket?: RequestTicket | null /* Moderator claims a RequestTicket.Update RequestTicket state from RESOLVED to MODERATION_CLAIMED */
  moderationDropRequestTicket?: RequestTicket | null /* Moderator drops a RequestTicket which that Moderator claimed before.Update RequestTicket state from MODERATION_CLAIMED to RESOLVED */
  moderationRejectRequestTicket?: RequestTicket | null /* Moderator rejects a RequestTicketUpdate RequestTicket state from MODERATION_CLAIMED to ACTIVE */
  notify?: SuccessResponse | null /* Notify a group of users by comment/push notification/email. */
  payByCreditCard?: StripeCharge | null /* Pay by a credit card */
  registerBrandAndUser?: BrandAndUserRegistrationResponse | null /* Register a new organisation and brand user account with email. */
  registerCreatorWithEmail?: EmailRegistrationResponse | null /* Register a new creator account with the email. */
  registerCreatorWithSocialAuth?: SocialRegistrationResponse | null /* Register a new creator account with the social identity. */
  registerProducerWithEmail?: EmailRegistrationResponse | null /* Register a new producer account with the email. */
  registerProducerWithSocialAuth?: SocialRegistrationResponse | null /* Register a new producer account with the social identity. */
  releaseRequestTicket?: SuccessResponse | null /* Release a RequestTicket that is currently in state ACTIVE or SCHEDULED.Returns { success: false } if state is wrong. */
  removeOpportunity?: SuccessResponse | null /* Remove an opportunity */
  removeOpportunityProducerProfile?: SuccessResponse | null /* Remove an OpportunityProducerProfile */
  resendConfirmationEmail?: SuccessResponse | null /* Trigger the platform to re-send the confirmation email. */
  resetPassword?: SuccessResponse | null /* Allow a user to reset his/her password with a temporary unique token. */
  resolveRequestTicket?: RequestTicket | null /* Resolve a RequestTicket that is currently in state ACTIVE. */
  scheduleRequestTicket?: RequestTicket | null /* Schedule or reschedule a request ticket.Mutation is accessible to Producer app. */
  setPassword?: SuccessResponse | null /* Allow a user to set his/her password. */
  startJob?: SuccessResponse | null /* Start a job */
  switchBrand?: AuthResponse | null /* Allow users to switch their current brand which would return a new JWT. */
  unlockAppUser?: SuccessResponse | null /* Unlock an app user. */
  updateApprovalState?: SuccessResponse | null
  updateAsset?: Asset | null
  updateBrandProfile?: Brand | null /* Update a brand */
  updateCreatorCreateService?: CreateService | null /* Update a creator create service */
  updateCreatorProfile?: CreatorProfile | null /* Update a creator profile */
  updateCreatorWorkContractRecommendations?: SuccessResponse | null /* Bulk update creator work contract recommendations */
  updateInvitation: WorkContractInvitation /* Update Work Contract Invitation */
  updateJob?: Job | null /* Update a job */
  updateMarketplaceProduct?: MarketplaceProduct | null
  updateNotifications?: SuccessResponse | null /* Marks given notification \(or all unread notifications for the current user if notificationUuid is not set)\as read */
  updateOpportunity?: Opportunity | null /* Update an opportunity information */
  updateOpportunityProducerProfile?: OpportunityProducerProfile | null /* Update an opportunity producer profile */
  updatePreferredCreator?: SuccessResponse | null /* Update preferred creator */
  updateProducerProfile: ProducerProfile /* Update producer profile.Mutation is accessible to Manager and Producer apps.Only Producers and Managers can use this mutation.Manager can change everything in any profile. */
  updateProject: Project /* Update a project */
  updateRequestTicket?: RequestTicket | null /* Update a RequestTicket info */
  updateShortlist?: SuccessResponse | null /* Creates or updates work contract shortlist for given user and work contract. */
  updateTask?: Task | null
  updateUser?: User | null /* Update a User Account */
  updateUserPaymentInfo?: User | null /* Update User Payment Information */
  updateWorkContract?: WorkContract | null /* Update work contract */
  updateWorkContractRecommendations?: SuccessResponse | null /* Bulk update work contract recommendations */
  uploadedAttachment?: SuccessResponse | null /* Mark the the asset attachment as having been uploaded successfully to Google Cloud Storage.Returns &#x60;{ &quot;success&quot;: false }&#x60; if attachment already marked as uploaded previously. */
}
/* A successful response */
export interface SuccessResponse {
  success: boolean
}
/* The authentication response */
export interface AuthResponse {
  accessToken: string /* The JWT that clients should use to see public info and authenticated requests. */
  jwt: string /* The JWT that clients should use to see public info and authenticated requests. */
  refreshToken: string /* The JWT that clients should use to get new pair of access and refresh tokens. */
}

export interface OpportunityProducerProfile {
  assignedAt?: DateTime | null
  completedAt?: DateTime | null
  opportunity: Opportunity
  producerProfile: User
  producerRole: OpportunityProducerRole
  reassignedAt?: DateTime | null
  uuid: string
}
/* The authentication response */
export interface AuthTokensResponse {
  accessToken: string /* The JWT that clients should use to see public info and authenticated requests. */
  refreshToken: string /* The JWT that clients should use to get new pair of access and refresh tokens. */
}

export interface SocialRegistrationResponse {
  accessToken: string /* The JWT that clients should use to see public info and authenticated requests. */
  jwt: string /* The JWT that clients should use to see public info and authenticated requests. */
  newUser: NewUser
  user: User /* TO BE DEPRECATED: Use newUser */
}
/* The user object with unprotected fields.This is to be returned only after new registration or in invites */
export interface NewUser {
  additionalEmails: string[]
  avatar?: CloudinaryImage | null
  confirmed?: boolean | null
  createdAt: DateTime
  dateOfBirth?: Date | null
  email: string
  facebookProfile?: string | null
  gender?: Gender | null
  linkedinProfile?: string | null
  locale?: string | null
  location?: Location | null
  name?: string | null
  nickname?: string | null
  phoneNumber?: string | null
  producerProfile?: ProducerProfile | null
  skypeUsername?: string | null
  timezone?: string | null
  twitterProfile?: string | null
  updatedAt: DateTime
  uuid: string
}

export interface BrandAndUserRegistrationResponse {
  brand: Brand
  newUser: NewUser
  tokens: AuthTokensResponse
}

export interface EmailRegistrationResponse {
  newUser: NewUser
  user: User /* TO BE DEPRECATED: Use newUser */
}
/* Inputs needed to filter content manager assets */
export interface ContentManagerFilterInput {
  assetType: ContentManagerAssetType
  videoState?: ContentManagerVideoState | null
  keyword?: string | null
  cityUuids?: string[] | null
  projectUuids?: string[] | null
  startAt?: DateTime | null
  endAt?: DateTime | null
  sortOrder?: string[] | null
}
/* Filters for user related queries */
export interface UserFilterInput {
  states?: UserState[] | null
  name?: string | null
  email?: string | null
}

export interface LocationFilterInput {
  city?: string | null
  state?: string | null
  countryCode?: string | null
}
/* Filters for producer related queries */
export interface ProducerFilterInput {
  online?: boolean | null /* deprecated, use &#x60;status&#x60; instead */
  status?: ProducerStatus | null
  activated?: boolean | null
  blocked?: boolean | null
  serviceQualityLevelSlugs?:
    | string[]
    | null /* Array of service quality level slugs. When the array is empty, ignore it */
}
/* Inputs needed for a quote */
export interface QuoteInput {
  budget?: number | null
  custom?: boolean | null
  description?: string | null
  countryUuid?: string | null
  cityUuid?: string | null
  productUuid?: string | null
  title?: string | null /* Default to English, &quot;New Shoot - Singapore&quot; */
  email?:
    | string
    | null /* Email field passed in, not processed, just for passing back the same information */
  overview?: string | null
  inspirationVideoUrls?: string[] | null
  shootStartAt?: DateTime | null /* To select &quot;NOW&quot;, leave this field empty or &quot;null&quot; */
  editDueAt?: DateTime | null /* Deprecated. editDue would be set later.To select &quot;NOW&quot;, leave this field empty or &quot;null&quot; */
  projectDueAt?: DateTime | null /* To select &quot;NOW&quot;, leave this field empty or &quot;null&quot; */
  videoProjectTemplateSlug?:
    | string
    | null /* The default value depends on getQuoteForm argument :videoProjectTemplateTypeIf videoProjectTemplateType is EDIT, defaults to &quot;singapore-edit&quot; package;If videoProjectTemplateType is SHOOT, defaults to &quot;singapore-shoot&quot; package;Possible values can be found from QuoteForm.videoProjectTemplates.slug */
  jobTemplatePackages?: JobTemplatePackageInput[] | null
  masterTimeProfileSlug?: string | null
  masterServiceQualityLevelSlug?: string | null
  marketPlaceProductId?:
    | string
    | null /* Set id that assign new Shoot&#x27;s to some MarketPlaceProduct */
  trackingUuid?:
    | string
    | null /* When a user starts a new shoot anywhere, generated this UUID to keep trackuser action before it is turned into a project. */
}

export interface JobTemplatePackageInput {
  jobTemplatePackageSlug: string /* Slug of selected JobTemplatePackage */
}
/* Filters for video search queries */
export interface VideoSearchInput {
  query?: string | null
  from: number
  size: number
  fromDate?: string | null
  toDate?: string | null
  ratings?: number[] | null
  minBudget?: number | null
  maxBudget?: number | null
  industry?: string | null
  country?: string | null
  videoType?: string | null
  brandTypes?: string[] | null
}

export interface AssetInput {
  type?: AssetType | null
  title?: string | null
  description?: string | null
  attachment?: GCSAttachmentInput | null
  externalLink?: ExternalLinkInput | null
}

export interface GCSAttachmentInput {
  fileName?: string | null
  fileSize?: number | null
  mimeType?:
    | string
    | null /* Mime type of content e.g &#x27;video/mp4&#x27;, &#x27;image/jpeg&#x27;. */
}

export interface ExternalLinkInput {
  url: string
}

export interface CommentInput {
  commentableUuid: string
  commentableType: CommentableType
  commenterUuid?: string | null
  body: string
}

export interface CreateServiceQualityLevelInput {
  slug: string
  state?: CreateServiceState | null /* For managers only */
}
/* Inputs needed for credit card creation */
export interface CreditCardInput {
  brandUuid: string /* Add credit card for this brand */
  cardBrand: string
  cardFunding: string
  expiryMonth: number
  expiryYear: number
  last4Digits: string
  permission: string /* &#x27;all&#x27; or &#x27;limited&#x27; */
  stripeToken: string
}

export interface DeviceInput {
  fcmRegistrationToken: string
  deviceType: DeviceType
}
/* Inputs needed for changing users password */
export interface ChangePasswordInput {
  currentPassword: string
  password: string
}

export interface AttachmentInput {
  attachableType?: AttachableType | null
  attachableId?: number | null
  fileName?: string | null
  fileSize?: string | null
  fileType?: string | null
  fileUrl?: string | null
  parentId?: number | null
  metaData?: JSONBlob | null
}
/* Inputs needed for sales tracking */
export interface TrackingInput {
  salesMedium?: string | null /* e.g. manager, direct, organic, referral, cpc, cta */
  salesSource?:
    | string
    | null /* e.g. platform, marketing, google, bing, yahoo, facebook, twitter, ... */
  salesCampaign?: string | null /* e.g. Revolve 101 */
  salesReferrer?: string | null /* e.g. https://facebook.com/... */
}
/* Inputs needed for updating and creating WorkContractInvitation */
export interface WorkContractInvitationInput {
  workContractUuid: string
  inviterUuid: string
  humanUuid: string
  state: WorkContractInvitationState
}
/* Inputs needed for updating and creating MarketplaceProduct */
export interface MarketplaceProductInput {
  name: string
  description: string
  linkTo?: string | null
  imageUrl?: string | null
  averagePrice?: PriceInput | null
  rating?: MarketplaceRatingInput | null
  promo?: string | null
  productMarketing?: JSONBlob | null
  productSpecs?: JSONBlob | null
  tagSlugs?: string[] | null /* Array of MarketplaceTag slugs */
  relatedProductsSlugs?: string[] | null /* Array of MarketplaceProduct slugs */
  isActive?: boolean | null
  videoProjectTemplateSlug?: string | null
  countryUuid?: string | null
  cityUuid?: string | null
}
/* Total price */
export interface PriceInput {
  amount: number
  currencyCode: string
}
/* Rating for a Marketplace product */
export interface MarketplaceRatingInput {
  average?: number | null
  count?: number | null
}
/* Inputs needed for creating an OpportunityProducerProfile */
export interface OpportunityProducerProfileCreateInput {
  opportunityUuid: string
  producerProfileUuid: string
  assignedAt?: DateTime | null
  completedAt?: DateTime | null
  reassignedAt?: DateTime | null
  producerRole?: OpportunityProducerRole | null
}
/* Inputs needed for a shoot */
export interface ShootInput {
  countryUuid?: string | null
  cityUuid?: string | null
  time?: DateTime | null /* To select &quot;NOW&quot;, leave this field empty or &quot;null&quot; */
  notes?: string | null
}
/* Inputs to create a RequestTicket */
export interface RequestTicketInput {
  urgency?: RequestTicketUrgency | null
  language?: RequestTicketLanguage | null
  targetUuid: string
  targetType: RequestTicketTargetType
  assigneeType: RequestTicketAssigneeType
  assigneeId?: string | null /* ignore this, use uuid through assignee_uuid instead */
  assigneeUuid?: string | null
  preferredProducerOnly?: boolean | null
  requestTicketTypeUuid: string
  details?: JSONBlob | null /* The request details in valid JSON string. We can accommodate any additional info. */
}
/* Input for sending communication by email/comment/push notification */
export interface NotifyInput {
  recipientGroups?: string[] | null
  actions?: string[] | null
  targetId?: number | null
  targetType?: string | null
  message?: string | null
  emailArgs?: NotifyEmailInput | null
}
/* Input for sending email */
export interface NotifyEmailInput {
  mailer?: string | null
  params?: JSON | null
}
/* Inputs needed for brand user registration with email and organisation information */
export interface BrandAndUserInput {
  tradingName: string
  website?: string | null
  countryUuid?: string | null
  cityUuid?: string | null
  firstName: string
  lastName: string
  email: string
  phoneNumber?: string | null
  referrerId?: string | null
}
/* Inputs needed for creator registration with email, phone number and password */
export interface CreatorEmailInput {
  name: string
  email: string
  nickname?: string | null
  password: string
  phoneNumber?: string | null
  avatar?: CloudinaryImageInput | null
}
/* Inputs needed for a cloudinary image.- LinkedIn: Follow what&#x27;s returned from getLinkedInProfile- Facebook: &#x60;{ cloudinaryId: &quot;&lt;facebook_user_id&gt;&quot;, cloudinaryType: &quot;facebook&quot; }&#x60;- User uploads a custom one: &#x60;{ cloudinaryId: &quot;&lt;cloudinary_id&gt;&quot;, cloudinaryType: &quot;upload&quot; }&#x60; */
export interface CloudinaryImageInput {
  cloudinaryId?: string | null
  cloudinaryType?: string | null
}
/* Inputs needed for user registration with social auth */
export interface CreatorSocialAuthInput {
  provider?: IdentityProvider | null /* Despite the GraphQL schema, this is not an optional field */
  token: string /* Note: Provide token as:- AccessToken for FACEBOOK- AuthorizationCode for LINKEDIN_OAUTH2 and- AccessToken for LINKEDIN_OAUTH2_ACCESS_TOKEN- AccessToken for APPLE */
  clientId?: string | null /* Used for AppleID Social Auth */
  name: string
  nickname?: string | null
  phoneNumber?: string | null
  avatar?: CloudinaryImageInput | null
}
/* Inputs needed for user registration with email and password */
export interface UserEmailInput {
  name: string
  email: string
  password: string
  phoneNumber?: string | null
  avatar?: CloudinaryImageInput | null
  nickname?: string | null /* deprecated, not supported anymore */
}
/* Inputs needed for user registration with social auth */
export interface UserSocialAuthInput {
  provider: IdentityProvider
  token: string /* Note: Provide token as:- AccessToken for FACEBOOK- AuthorizationCode for LINKEDIN_OAUTH2 and- AccessToken for LINKEDIN_OAUTH2_ACCESS_TOKEN- AccessToken for APPLE */
  clientId?: string | null /* Used for AppleID Social Auth */
  name?: string | null
  nickname?: string | null
  phoneNumber?: string | null
  avatar?: CloudinaryImageInput | null
}
/* Inputs needed for setting users password */
export interface SetPasswordInput {
  password: string
  passwordConfirmation: string
}
/* Inputs needed for brand profile update */
export interface BrandUpdateInput {
  name?: string | null
  website?: string | null
  isPremium?: boolean | null
  isKeyAccount?: boolean | null
  isElite?: boolean | null
  size?: BrandSize | null
  cityUuid?: string | null
  keyAccountEndDate?: DateTime | null
  eliteEndDate?: DateTime | null
  premiumEndDate?: DateTime | null
  avatar?: CloudinaryImageInput | null
  industryUuids?:
    | string[]
    | null /* These will override all existing brand industry.Pass empty list [] to remove industries from brand. */
  tagIds?: number[] | null
}
/* Inputs needed for updating user */
export interface UpdateUserInput {
  timezone?: string | null
  locale?: string | null /* Example: &quot;en&quot;, &quot;ja&quot; */
  skypeUsername?: string | null
  name?: string | null
  phoneNumber?: string | null
  avatar?: CloudinaryImageInput | null
  dateOfBirth?: Date | null
  gender?: Gender | null
  nickname?: string | null /* Ignored */
  facebookProfile?: string | null
  twitterProfile?: string | null
  linkedinProfile?: string | null
  googlePlaceId?: string | null
  countryUuid?: string | null
  cityUuid?: string | null
}

export interface CreatorReferenceInput {
  name?: string | null
  email?: string | null
}
/* Inputs needed for updating creator profile */
export interface CreatorProfileInput {
  bio?: string | null
  creatorReference?: CreatorReferenceInput | null
  languageUuids?: string[] | null
  industryUuids?: string[] | null
  clientNames?: string[] | null
}
/* Inputs needed to update a creator work contract recommendations */
export interface CreatorWorkContractRecommendationInput {
  creatorUuid: string
  creatorWorkContractRecommendations?: JSONBlob | null
}

export interface JobInput {
  nameOverride?: string | null
  description?: string | null
  dueDate?: DateTime | null
  humanUuid: string
  approverUuid: string
  skillUuid: string
  skillLevelUuid: string
}
/* Inputs needed for updating an opportunity */
export interface OpportunityInput {
  name?: string | null
  convertedAt?: DateTime | null
  currencyCode?: string | null
  inProgressAt?: DateTime | null
  lostAt?: DateTime | null
  value?: number | null
  preferredProducerOnly?: boolean | null
  priority?: OpportunityPriority | null
  salesforceId?: string | null
  sourceType?: OpportunitySourceType | null
  state?: OpportunityState | null
}
/* Inputs needed for updating an OpportunityProducerProfile */
export interface OpportunityProducerProfileUpdateInput {
  opportunityUuid?: string | null
  producerProfileUuid?: string | null
  assignedAt?: DateTime | null
  completedAt?: DateTime | null
  reassignedAt?: DateTime | null
  producerRole?: OpportunityProducerRole | null
}
/* Inputs needed for updating producer profile */
export interface ProducerProfileInput {
  online?: boolean | null
  status?: ProducerStatus | null
  activated?: boolean | null
  serviceQualityLevelSlug?: string | null
  requestTicketTypeUuids?: string[] | null
  languageUuids?: string[] | null
}
/* Inputs needed for updating video project */
export interface UpdateVideoProjectInput {
  name?: string | null
  description?: string | null
  inspirationVideoUrls?: string[] | null
  countryUuid?: string | null
  cityUuid?: string | null
  overview?: string | null
  shootStartAt?: DateTime | null
  projectDueAt?: DateTime | null
}
/* Inputs to update a RequestTicket */
export interface RequestTicketUpdateInput {
  urgency?: RequestTicketUrgency | null
  language?: RequestTicketLanguage | null
  details?: JSONBlob | null /* The request details in valid JSON string. We can accommodate any additional info. */
}
/* Inputs needed for updating and creating Task */
export interface TaskInput {
  name: string
  description: string
  overridable?: boolean | null
  position?: number | null
  locale?: string | null /* Example: &quot;en&quot;, &quot;ja&quot; */
}
/* Inputs needed for updating user payment information */
export interface UpdateUserPaymentInput {
  paypalAddress?: string | null
  salesTaxNumber?: string | null
}

export interface WorkContractInput {
  published?: boolean | null
}
/* Inputs needed to update a work contract recommendations */
export interface WorkContractRecommendationInput {
  workContractUuid: string
  workContractRecommendations?: JSONBlob | null
}
export interface AllAttachmentsQueryArgs {
  brandUuid: string
}
export interface AllBriefOptionGroupsQueryArgs {
  slugs?: string[] | null
}
export interface AllContentManagerAssetsQueryArgs {
  brandUuid: string
  filterParams?: JSON | null
  filterInput?: ContentManagerFilterInput | null
  page?: number | null
  pageSize?: number | null
}
export interface AllContentManagerAttachmentsQueryArgs {
  brandUuid: string
  filterParams?: JSON | null
  page?: number | null
  pageSize?: number | null
}
export interface AllContentManagerCitiesQueryArgs {
  brandUuid: string
  filterParams?: JSON | null
  filterInput?: ContentManagerFilterInput | null
  page?: number | null
  pageSize?: number | null
}
export interface AllContentManagerProjectsQueryArgs {
  brandUuid: string
  filterParams?: JSON | null
  filterInput?: ContentManagerFilterInput | null
  page?: number | null
  pageSize?: number | null
}
export interface AllCreatorsQueryArgs {
  userFilter?: UserFilterInput | null
  locationFilter?: LocationFilterInput | null
  orderDirection?: OrderDirection | null
  orderBy?: UserOrder | null
  page?: number | null
  pageSize?: number | null
}
export interface AllCreditCardsQueryArgs {
  brandUuid?: string | null
}
export interface AllJobsQueryArgs {
  states?: JobState[] | null
  page?: number | null
  pageSize?: number | null
  startedBefore?: string | null
  startedAfter?: string | null
  orderBy?: JobOrder | null
  orderDirection?: OrderDirection | null
}
export interface AllOpportunitiesQueryArgs {
  states?: OpportunityState[] | null
  sourceTypes?: OpportunitySourceType[] | null
  priorities?: OpportunityPriority[] | null
  page?: number | null
  pageSize?: number | null
}
export interface AllOrganisationsQueryArgs {
  keyword: string
}
export interface AllProducersQueryArgs {
  producerFilter?: ProducerFilterInput | null
  locationFilter?: LocationFilterInput | null
  page?: number | null
  pageSize?: number | null
}
export interface AllProductsQueryArgs {
  page?: number | null
  pageSize?: number | null
}
export interface AllProductsByBrandQueryArgs {
  brandUuid: string
  page?: number | null
  pageSize?: number | null
}
export interface AllProductsByCategoryQueryArgs {
  marketplaceCategoryUuid: string
  page?: number | null
  pageSize?: number | null
}
export interface AllProjectsQueryArgs {
  state?: ProjectState | null
  states?: ProjectState[] | null
  brandUuid?: string | null
  productUuid?: string | null
}
export interface AllProjectsPaginatedQueryArgs {
  state?: ProjectState | null
  states?: ProjectState[] | null
  brandUuid?: string | null
  productUuid?: string | null
  projectLevels?: ProjectLevel[] | null
  page?: number | null
  pageSize?: number | null
  orderBy?: ProjectOrder | null
  orderDirection?: OrderDirection | null
}
export interface AllRequestTicketTypesQueryArgs {
  forCurrentApp?: boolean | null
}
export interface AllRequestTicketsQueryArgs {
  states?: RequestTicketState[] | null
  assigneeType?: RequestTicketAssigneeType | null
  assigneeEmail?: string[] | null
  targetType?: RequestTicketTargetType | null
  targetUuid?: string | null /* Deprecated: use targetUuids instead */
  targetUuids?: string[] | null
  requestTicketTypeUuids?: string[] | null
  requestTypeName?:
    | string[]
    | null /* The name of the request type. A request type contains multiple &#x60;RequestTicketType&#x60;s&#x27;.In the actual model, it&#x27;s the field &#x60;RequestTicketType#request_type&#x60; */
  requesterEmails?: string[] | null
  orderBy?: RequestTicketOrder | null
  orderDirection?: OrderDirection | null
  page?: number | null
  pageSize?: number | null
  requesterTypes?: RequestTicketRequesterType[] | null
  brandUuid?: string | null
  billingOrganisationUuid?: string[] | null
  urgency?: RequestTicketUrgency[] | null
}
export interface AllTasksByHumanQueryArgs {
  humanUuid: string
  page?: number | null
  pageSize?: number | null
}
export interface AllTasksByJobQueryArgs {
  jobUuid: string
  page?: number | null
  pageSize?: number | null
}
export interface AllWorkContractApplicationsQueryArgs {
  states?: WorkContractApplicationState[] | null
}
export interface AllWorkContractInvitationsQueryArgs {
  states?: WorkContractInvitationState[] | null
}
export interface CalcProductCostQueryArgs {
  productUuid: string
}
export interface CalcProductCostForLocationQueryArgs {
  productUuid: string
  cityUuid?: string | null
  countryUuid?: string | null
}
export interface CheckEmailQueryArgs {
  email: string
}
export interface CheckNameQueryArgs {
  name: string
}
export interface CheckWebsiteQueryArgs {
  website: string
}
export interface ConfigGetSectionInfoQueryArgs {
  sectionSlug: string /* identifier of the UI element */
}
export interface FindCityQueryArgs {
  searchTerm?: string | null
  page?: number | null
  pageSize?: number | null
  countryUuid?: string | null
}
export interface GetActivityFeedQueryArgs {
  feedableUuid?: string | null
  feedableType?: FeedableType | null
  startedBefore?: string | null
  commentTypes?: FeedCommentType[] | null
  eventTypes?: string[] | null
  orderDirection?: OrderDirection | null
  page?: number | null
  pageSize?: number | null
}
export interface GetBillingCurrencyQueryArgs {
  googlePlaceId?: string | null
  countryUuid?: string | null
}
export interface GetBrandProfileQueryArgs {
  brandUuid: string
}
export interface GetBrandStatsQueryArgs {
  brandUuid: string
}
export interface GetChargeQueryArgs {
  chargeId: string
}
export interface GetCommentsQueryArgs {
  commentableUuid?: string | null
  commentableType?: CommentableType | null
  startedBefore?: string | null
  orderDirection?: OrderDirection | null
  page?: number | null
  pageSize?: number | null
}
export interface GetCreatorProfileQueryArgs {
  userUuid?: string | null
}
export interface GetEmailByResetPasswordTokenQueryArgs {
  token: string
}
export interface GetEventsQueryArgs {
  eventableUuid: string
  eventableType: EventableType
  eventTypes?: string[] | null
  orderDirection?: OrderDirection | null
  page?: number | null
  pageSize?: number | null
}
export interface GetJobQueryArgs {
  jobUuid: string
}
export interface GetLinkedInProfileQueryArgs {
  authorizationCode: string
}
export interface GetLocalCurrencyQueryArgs {
  googlePlaceId?: string | null
  countryUuid?: string | null
}
export interface GetLocationProductsQueryArgs {
  countryUuid?: string | null
  cityUuid?: string | null
  page?: number | null
  pageSize?: number | null
}
export interface GetMarketPlaceProductQueryArgs {
  slug: string
}
export interface GetMarketPlaceProductsQueryArgs {
  tagSlugs?:
    | string[]
    | null /* Get products with given list of tag slugs; would raise error if any of the tag slug non exist */
  excludeTagSlugs?: string[] | null /* Exclude products with any tags from this list */
  excludeProductSlugs?: string[] | null /* Exclude products with any slugs from this list */
  marketPlaceProductUuid?: string[] | null /* Returns related products to a specific product */
  page?: number | null
  pageSize?: number | null
}
export interface GetNotificationsQueryArgs {
  notifiableUuid?: string | null
  notifiableType?: NotifiableType | null
  unread?: boolean | null
  page?: number | null
  pageSize?: number | null
}
export interface GetOpportunityQueryArgs {
  opportunityUuid: string
}
export interface GetProducerProfileQueryArgs {
  userUuid?: string | null /* If no userUuid given profile of the current_user will be returned */
}
export interface GetProductQueryArgs {
  productUuid: string
}
export interface GetProductLocationsQueryArgs {
  productUuid: string
  page?: number | null
  pageSize?: number | null
}
export interface GetProjectQueryArgs {
  projectUuid: string
}
export interface GetQuoteFormQueryArgs {
  quote: QuoteInput
  videoProjectTemplateType: VideoProjectTemplateType
  trackingUuid?: string | null
}
export interface GetRequestAssigneesQueryArgs {
  videoProjectUuid: string
  targetUuid?: string | null
  requestTicketTypeName: RequestTicketTypeName
  targetType?: RequestTicketTargetType | null
  assigneeType?: RequestTicketAssigneeType | null
  preferredProducer?: boolean | null
}
export interface GetRequestTicketQueryArgs {
  uuid?: string | null
}
export interface GetShootQueryArgs {
  shootUuid: string
}
export interface GetShortlistQueryArgs {
  shortlistUuid: string
}
export interface GetTranscodedAttachmentsQueryArgs {
  brandUuid: string
  attachmentUuid: string
}
export interface GetVideoQueryArgs {
  videoUuid: string
}
export interface GetWorkContractQueryArgs {
  workContractUuid: string
}
export interface GetWorkContractApplicationQueryArgs {
  applicationUuid: string
}
export interface GetWorkContractInvitationQueryArgs {
  invitationUuid: string
}
export interface SearchVideoByIdQueryArgs {
  videoId: number
  from: number
  size: number
  innerHit?: number | null
}
export interface SearchVideosQueryArgs {
  searchInput?: VideoSearchInput | null
}
export interface SearchVideosByCategoryQueryArgs {
  categoryName: string
}
export interface ValidateNewBrandQueryArgs {
  website?: string | null
}
export interface ValidateNewUserQueryArgs {
  email: string
}
export interface ValidateNewUserNameQueryArgs {
  name: string
}
export interface ValidatePasswordQueryArgs {
  email: string
  password: string
}
export interface CommentsRequestTicketArgs {
  after?: string | null
  types?: CommentType[] | null
}
export interface BasePriceSkillArgs {
  currencyCode?: string | null
}
export interface ServiceQualityLevelRatesSkillArgs {
  currencyCode?: string | null
}
export interface AcceptWorkContractInvitationMutationArgs {
  invitationUuid: string
}
export interface AddAnalyticOrderMutationArgs {
  projectUUID: string
  salesChannel?: string | null /* channel like MarketPlace or CustomProject */
}
export interface AddAssetMutationArgs {
  asset: AssetInput
}
export interface AddCommentMutationArgs {
  comment: CommentInput
}
export interface AddCreatorClientMutationArgs {
  name: string
  userUuid?: string | null /* Uuid of the target creator. Ignored when requested as a creator. */
}
export interface AddCreatorCreateServiceMutationArgs {
  userUuid?: string | null /* Uuid of the target creator. Ignored when requested as a creator. */
  skillSlug: string
  timeProfileSlugs: string[]
  serviceQualityLevels?: CreateServiceQualityLevelInput[] | null
  serviceQualityLevelSlugs?: string[] | null
  workExampleUuids: string[] /* The given array of uuids will be the new assoicated WorkExamples.To remove a particular WorkExample, provide the previous array of uuid except the one to be removed. */
}
export interface AddCreatorEquipmentMutationArgs {
  category: EquipmentCategory
  name: string
  userUuid?: string | null /* Uuid of the target creator. Ignored when requested as a creator. */
}
export interface AddCreditCardMutationArgs {
  creditCard: CreditCardInput
}
export interface AddDeviceMutationArgs {
  device: DeviceInput
}
export interface AddVideoPlatformIntegrationMutationArgs {
  provider: VideoPlatformIntegrationProvider
  authorizationCode: string
}
export interface AnalyticsRegisterEventMutationArgs {
  data?: JSON | null
  eventType?: string | null
  location?: string | null
}
export interface ApplyForWorkContractMutationArgs {
  workContractUuid: string
}
export interface CancelRequestTicketMutationArgs {
  uuid: string
}
export interface ChangePasswordMutationArgs {
  user?: ChangePasswordInput | null
}
export interface ClaimRequestTicketMutationArgs {
  uuid: string
}
export interface CompleteCreatorProfileActivationMutationArgs {
  userUuid: string
}
export interface CompleteJobMutationArgs {
  jobUuid: string
}
export interface ConfirmEmailAndLoginMutationArgs {
  confirmationToken: string
}
export interface CreateAttachmentMutationArgs {
  attachment?: AttachmentInput | null
}
export interface CreateCustomProjectMutationArgs {
  brandUuid: string
  productUuid?: string | null
  quote?: QuoteInput | null
  trackingInput?: TrackingInput | null
}
export interface CreateInvitationMutationArgs {
  workContractInvitation: WorkContractInvitationInput
}
export interface CreateMarketplaceProductMutationArgs {
  marketplaceProduct: MarketplaceProductInput
}
export interface CreateOpportunityMutationArgs {
  brandUuid: string
}
export interface CreateOpportunityProducerProfileMutationArgs {
  opportunityProducerProfileInput: OpportunityProducerProfileCreateInput
}
export interface CreateProjectMutationArgs {
  brandUuid: string
  productUuid?: string | null
  quote?: QuoteInput | null
  shoots?: ShootInput[] | null
  trackingInput?: TrackingInput | null
}
export interface CreateProjectVariationMutationArgs {
  variation_type: string
  video_uuid: string
}
export interface CreateRequestTicketMutationArgs {
  requestTicket: RequestTicketInput
}
export interface CustomerAcceptPurchaseMutationArgs {
  videoProjectUuid: string
  chargeToAccount?: boolean | null
  eventComment?: string | null
}
export interface DeclineRequestTicketMutationArgs {
  uuid: string
}
export interface DeclineWorkContractInvitationMutationArgs {
  invitationUuid: string
}
export interface DeleteAssetMutationArgs {
  uuid: string
}
export interface DeleteCommentMutationArgs {
  uuid: string
}
export interface DeleteCreatorClientMutationArgs {
  clientUuid: string
  userUuid?: string | null /* Uuid of the target creator. Ignored when requested as a creator. */
}
export interface DeleteCreatorCreateServiceMutationArgs {
  uuid: string
}
export interface DeleteCreatorEquipmentMutationArgs {
  equipmentUuid: string
  userUuid?: string | null /* Uuid of the target creator. Ignored when requested as a creator. */
}
export interface DeleteCreditCardMutationArgs {
  creditCardId: string
}
export interface DeleteInvitationMutationArgs {
  workContractInvitationUuid: string
}
export interface DeleteMarketplaceProductMutationArgs {
  marketplaceProductUuid: string
}
export interface DeleteShortlistMutationArgs {
  shortlistUuid: string
}
export interface EditCommentMutationArgs {
  uuid: string
  body: string
}
export interface ForgotPasswordMutationArgs {
  email: string
}
export interface GetAccessTokenMutationArgs {
  refreshToken: string
}
export interface LinkAttachmentMutationArgs {
  attachmentUuid: string
  projectUuid: string
}
export interface LockAppUserMutationArgs {
  userUuid: string /* UUID of a user to unlock */
  appUuid: string /* UUID of an app to unlock for the user */
}
export interface LoginEmailMutationArgs {
  email: string
  password: string
}
export interface LoginManagerWithGoogleAuthMutationArgs {
  idToken: string
}
export interface LoginSocialAuthMutationArgs {
  provider?: IdentityProvider | null /* Despite the GraphQL schema, this is not an optional field */
  token: string
  clientId?: string | null /* Used for AppleID Social Auth */
}
export interface LogoutDeviceMutationArgs {
  device: DeviceInput
}
export interface MarkRequestTicketNotificationsReadMutationArgs {
  uuid: string
}
export interface ModerationApproveRequestTicketMutationArgs {
  uuid: string
}
export interface ModerationClaimRequestTicketMutationArgs {
  uuid: string
}
export interface ModerationDropRequestTicketMutationArgs {
  uuid: string
}
export interface ModerationRejectRequestTicketMutationArgs {
  uuid: string
  detail: string /* Reject Ticket Notes, if detail is an empty string, default detail message would be used. */
}
export interface NotifyMutationArgs {
  body: NotifyInput
}
export interface PayByCreditCardMutationArgs {
  invoiceUuid: string
  creditCardId?: string | null
  stripeToken?: string | null
}
export interface RegisterBrandAndUserMutationArgs {
  brandAndUser: BrandAndUserInput
}
export interface RegisterCreatorWithEmailMutationArgs {
  user: CreatorEmailInput
}
export interface RegisterCreatorWithSocialAuthMutationArgs {
  user: CreatorSocialAuthInput
}
export interface RegisterProducerWithEmailMutationArgs {
  user: UserEmailInput
}
export interface RegisterProducerWithSocialAuthMutationArgs {
  user: UserSocialAuthInput
}
export interface ReleaseRequestTicketMutationArgs {
  uuid: string
  detail: string /* Release Notes, if detail is an empty string, default detail message would be used. */
}
export interface RemoveOpportunityMutationArgs {
  opportunityUuid: string
}
export interface RemoveOpportunityProducerProfileMutationArgs {
  opportunityProducerProfileUuid: string
}
export interface ResendConfirmationEmailMutationArgs {
  email: string
}
export interface ResetPasswordMutationArgs {
  resetPasswordToken: string
  password: string
}
export interface ResolveRequestTicketMutationArgs {
  uuid: string
  detail?:
    | string
    | null /* Resolution Notes, if detail is an empty string, default detail message would be used */
}
export interface ScheduleRequestTicketMutationArgs {
  uuid: string
  scheduleFor: DateTime
}
export interface SetPasswordMutationArgs {
  user?: SetPasswordInput | null
}
export interface StartJobMutationArgs {
  jobUuid: string
}
export interface SwitchBrandMutationArgs {
  brandUuid: string
}
export interface UnlockAppUserMutationArgs {
  userUuid: string /* UUID of a user to unlock */
  appUuid: string /* UUID of an app to unlock for the user */
}
export interface UpdateApprovalStateMutationArgs {
  approvableUuid: string
  approvableType?: ApprovableType | null
  note?: string | null /* comment or note on the approval / rejection */
  state?: ApprovableState | null
}
export interface UpdateAssetMutationArgs {
  uuid: string
  asset: AssetInput
}
export interface UpdateBrandProfileMutationArgs {
  brandUuid: string
  brandUpdateInput: BrandUpdateInput
}
export interface UpdateCreatorCreateServiceMutationArgs {
  uuid: string
  timeProfileSlugs?: string[] | null
  serviceQualityLevelSlugs?:
    | string[]
    | null /* To be deprecated, use serviceQualityLevels instead */
  serviceQualityLevels?: CreateServiceQualityLevelInput[] | null
  workExampleUuids?: string[] | null
  activatedServiceQualityLevelSlug?: string | null /* For managers only */
  activationType?: CreateServiceActivationType | null
  rejectionComment?: string | null /* For managers only */
  rateComment?: string | null /* For managers only */
  rejectionReason?: CreateServiceRejectionReason | null /* For managers only */
}
export interface UpdateCreatorProfileMutationArgs {
  userUuid?: string | null /* Uuid of the target creator. Ignored when requested as a creator. */
  user?: UpdateUserInput | null /* Deprecated. Please use the &#x60;updateUser&#x60; mutation instead */
  bio?: string | null /* deprecated, put under creatorProfile instead */
  creatorReference?: CreatorReferenceInput | null /* deprecated, put under creatorProfile instead */
  creatorProfile?: CreatorProfileInput | null
}
export interface UpdateCreatorWorkContractRecommendationsMutationArgs {
  body?: CreatorWorkContractRecommendationInput[] | null
}
export interface UpdateInvitationMutationArgs {
  workContractInvitationUuid: string
  workContractInvitationInput: WorkContractInvitationInput
}
export interface UpdateJobMutationArgs {
  jobUuid: string
  jobInput: JobInput
}
export interface UpdateMarketplaceProductMutationArgs {
  marketplaceProductUuid: string
  marketplaceProduct: MarketplaceProductInput
}
export interface UpdateNotificationsMutationArgs {
  notificationUuid?: string | null
}
export interface UpdateOpportunityMutationArgs {
  opportunityUuid: string
  opportunityInput: OpportunityInput
}
export interface UpdateOpportunityProducerProfileMutationArgs {
  opportunityProducerProfileUuid: string
  opportunityProducerProfileInput: OpportunityProducerProfileUpdateInput
}
export interface UpdatePreferredCreatorMutationArgs {
  brandUuid: string
  creatorUuid: string
  preferenceState: PreferenceState
}
export interface UpdateProducerProfileMutationArgs {
  userUuid?: string | null /* Uuid of the target producer. Ignored when requested as a producer. */
  producerProfile?: ProducerProfileInput | null
}
export interface UpdateProjectMutationArgs {
  videoProjectUuid: string
  videoProject: UpdateVideoProjectInput
}
export interface UpdateRequestTicketMutationArgs {
  uuid: string
  requestTicket: RequestTicketUpdateInput
  requestTicketTypeUuid: string
}
export interface UpdateShortlistMutationArgs {
  humanUuid: string
  workContractUuid: string
}
export interface UpdateTaskMutationArgs {
  taskUuid: string
  task?: TaskInput | null
  isComplete?: boolean | null
  jobUuid?: string | null
}
export interface UpdateUserMutationArgs {
  userUuid?: string | null
  user?: UpdateUserInput | null
}
export interface UpdateUserPaymentInfoMutationArgs {
  userUuid?: string | null
  paymentInfo?: UpdateUserPaymentInput | null
}
export interface UpdateWorkContractMutationArgs {
  workContractUuid: string
  workContractInput: WorkContractInput
  publisherUuid?: string | null
}
export interface UpdateWorkContractRecommendationsMutationArgs {
  body?: WorkContractRecommendationInput[] | null
}
export interface UploadedAttachmentMutationArgs {
  uuid?: string | null /* deprecated, no longer required */
  attachmentUuid: string /* UUID of the GCS::Attachment uploading under the asset */
}

export enum ApprovableState {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum PayCycle {
  FLEXIBLE = 'FLEXIBLE',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  END_OF_MONTH = 'END_OF_MONTH',
  FROM_ISSUE_DATE = 'FROM_ISSUE_DATE',
}

export enum WeekDay {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}
/* attachable type */
export enum BrandHistory {
  one_older_vid = 'one_older_vid',
  few_older_vids = 'few_older_vids',
  one_ok_vid = 'one_ok_vid',
  one_great_vid = 'one_great_vid',
  few_great_vids = 'few_great_vids',
}
export enum DivisionState {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}
export enum BrandFunctions {
  CUSTOMER = 'CUSTOMER',
  REFERRER = 'REFERRER',
  RESELLER = 'RESELLER',
  AGENCY = 'AGENCY',
  DISTRIBUTOR = 'DISTRIBUTOR',
  EVENT_PROVIDER = 'EVENT_PROVIDER',
}
export enum BrandHappiness {
  LOVE__RECOMMEND_US = 'LOVE__RECOMMEND_US',
  LIKE_US_LOTS = 'LIKE_US_LOTS',
  PRETTY_HAPPY = 'PRETTY_HAPPY',
  LET_DOWN_A_BIT = 'LET_DOWN_A_BIT',
  LET_DOWN_BIG_TIME = 'LET_DOWN_BIG_TIME',
  NOT_INTERESTED = 'NOT_INTERESTED',
  SEE_YOU_LATERS = 'SEE_YOU_LATERS',
}

export enum BrandDepartment {
  SALES = 'SALES',
  PRODUCT = 'PRODUCT',
  HR = 'HR',
  MARKETING = 'MARKETING',
  FINANCE = 'FINANCE',
  DIGITAL = 'DIGITAL',
  INTERNAL_COMMS = 'INTERNAL_COMMS',
  EXTERNAL_COMMS = 'EXTERNAL_COMMS',
  EXECUTIVE_COMMS = 'EXECUTIVE_COMMS',
  INTERNAL_STUDIO = 'INTERNAL_STUDIO',
  EVENTS = 'EVENTS',
}
export enum BrandCoolness {
  VERY_UNCOOL = 'VERY_UNCOOL',
  UNCOOL = 'UNCOOL',
  OK = 'OK',
  COOL = 'COOL',
  VERY_COOL = 'VERY_COOL',
}
export enum AttachableType {
  ORGANISATION = 'ORGANISATION',
  HUMAN = 'HUMAN',
  CONTENT_CHANNEL = 'CONTENT_CHANNEL',
  VIDEO_PROJECT = 'VIDEO_PROJECT',
  SHOOT = 'SHOOT',
  SHOOT_FOOTAGE = 'SHOOT_FOOTAGE',
  VIDEO = 'VIDEO',
  WORK_CONTRACT = 'WORK_CONTRACT',
  CUSTOMER_CONTRACT = 'CUSTOMER_CONTRACT',
  CAMPAIGN = 'CAMPAIGN',
  CONTENT_GROUP = 'CONTENT_GROUP',
  CONTENT_TYPE = 'CONTENT_TYPE',
}

export enum SubscriptionFeature {
  BRAND_TEMPLATES = 'BRAND_TEMPLATES',
  CONTENT_LIBRARY = 'CONTENT_LIBRARY',
  PREFERRED_CREATORS = 'PREFERRED_CREATORS',
  WALLET = 'WALLET',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNSPECIFIED = 'UNSPECIFIED',
}

export enum WorkflowRequestState {
  UNSTARTED = 'UNSTARTED',
  STARTED = 'STARTED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  DISPUTED = 'DISPUTED',
  COMPLETED = 'COMPLETED',
}

export enum CurrencyPositionEnum {
  PREFIX = 'PREFIX',
  POSTFIX = 'POSTFIX',
}

export enum JobTemplateType {
  SHOOT = 'SHOOT',
}

/* Possible service types of job templates and job template packages */
export enum ServiceType {
  CREATOR = 'CREATOR',
  PRODUCER = 'PRODUCER',
  EDIT = 'EDIT',
}

export enum VideoProjectTemplateType {
  SHOOT = 'SHOOT',
  EDIT = 'EDIT',
  ALL = 'ALL',
}

export enum JobState {
  UNSTARTED = 'UNSTARTED',
  STARTED = 'STARTED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  DISPUTED = 'DISPUTED',
  COMPLETED = 'COMPLETED',
}

export enum WorkContractApplicationState {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
}

export enum WorkContractInvitationState {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
}

export enum WorkContractState {
  UNSTARTED = 'UNSTARTED',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
}

export enum ProductActivationStateType {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum ProjectLevel {
  LEVEL1 = 'LEVEL1',
  LEVEL2 = 'LEVEL2',
  LEVEL3 = 'LEVEL3',
  PREMIUM_PLUS = 'PREMIUM_PLUS',
  OLD_ACCOUNT_LOAD = 'OLD_ACCOUNT_LOAD',
  SUBSCRIPTION_PACKAGE = 'SUBSCRIPTION_PACKAGE',
  PRE_PAY_PACKAGE = 'PRE_PAY_PACKAGE',
  USAGE_PROJECT = 'USAGE_PROJECT',
  PROPOSAL = 'PROPOSAL',
  TEMPLATES = 'TEMPLATES',
}

export enum ShootWorkflowState {
  COMPLETED = 'COMPLETED',
  READY = 'READY',
  UNPLANNED = 'UNPLANNED',
  PLANNING = 'PLANNING',
}

export enum ProjectState {
  PURCHASING = 'PURCHASING',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  LOST = 'LOST',
}

export enum VideoWorkflowState {
  PLANNING = 'PLANNING',
  AWAITING_SEO_DETAILS = 'AWAITING_SEO_DETAILS',
  READY_FOR_PUBLISH = 'READY_FOR_PUBLISH',
  READY_FOR_REVIEW = 'READY_FOR_REVIEW',
  LIVE = 'LIVE',
  READY_FOR_EDIT = 'READY_FOR_EDIT',
}

export enum CreateServiceActivationType {
  ONLINE = 'ONLINE',
  PHONE = 'PHONE',
}

export enum CreateServiceState {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum CreateServiceRejectionReason {
  EVIDENCE = 'EVIDENCE',
  QUALITY = 'QUALITY',
}

export enum AssetContentType {
  ATTACHMENT = 'ATTACHMENT',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
}

export enum AssetType {
  WORK_EXAMPLE = 'WORK_EXAMPLE',
  PERSONAL_VIDEO = 'PERSONAL_VIDEO',
}

export enum EquipmentCategory {
  CAMERA = 'CAMERA',
  LENSES = 'LENSES',
  AUDIO = 'AUDIO',
  LIGHTING = 'LIGHTING',
  TRIPODS_CRANES_AND_DOLLYS = 'TRIPODS_CRANES_AND_DOLLYS',
  STABILISATION = 'STABILISATION',
  DRONES = 'DRONES',
  MONITORS_AND_TELEPROMPTERS = 'MONITORS_AND_TELEPROMPTERS',
  EDITING_AND_ANIMATION_SOFTWARE = 'EDITING_AND_ANIMATION_SOFTWARE',
  GRIPS = 'GRIPS',
  OTHER = 'OTHER',
}

export enum CreatorProfileState {
  PROFILE = 'PROFILE',
  SKILLS = 'SKILLS',
  ACTIVATION = 'ACTIVATION',
  BOOK_ACTIVATION = 'BOOK_ACTIVATION',
  AWAITING_ACTIVATION = 'AWAITING_ACTIVATION',
  COMPLETED = 'COMPLETED',
}

export enum RequestTicketAssigneeType {
  BRAND = 'BRAND',
  PRODUCER = 'PRODUCER',
  CREATOR = 'CREATOR',
  JOBOWNER = 'JOBOWNER',
}

/* Possible types of comments */
export enum CommentType {
  COMMENT = 'COMMENT',
  EMAIL = 'EMAIL',
  MEETING = 'MEETING',
  NOTE = 'NOTE',
  PHONE_CALL = 'PHONE_CALL',
  PROPOSAL = 'PROPOSAL',
  NORMAL = 'NORMAL',
  RELEASE = 'RELEASE',
  RESOLVE = 'RESOLVE',
  MODERATION_REJECT = 'MODERATION_REJECT',
}

export enum ContentGroupType {
  SERIES = 'SERIES',
  EVENT = 'EVENT',
  CAMPAIGN = 'CAMPAIGN',
  SET = 'SET',
}

export enum ContentChannelType {
  BRAND = 'BRAND',
  EVENT = 'EVENT',
  PRODUCT = 'PRODUCT',
  CUSTOMER = 'CUSTOMER',
  INTERNAL_COMMS = 'INTERNAL_COMMS',
  PEOPLE = 'PEOPLE',
  LOCATION = 'LOCATION',
  CAMPAIGN = 'CAMPAIGN',
  NEWS = 'NEWS',
  OTHER = 'OTHER',
}

export enum RequestTicketLanguage {
  ENGLISH = 'ENGLISH',
  JAPANESE = 'JAPANESE',
}

export enum RequestTicketMatchedReason {
  PREFERRED = 'PREFERRED',
  WORKED_BEFORE = 'WORKED_BEFORE',
  CLOSEST = 'CLOSEST',
}

export enum RequestTicketRequesterType {
  GEN1_BOT = 'GEN1_BOT',
  BOT = 'BOT',
  BRAND = 'BRAND',
  PRODUCER = 'PRODUCER',
  CREATOR = 'CREATOR',
}

export enum RequestTicketState {
  UNASSIGNED = 'UNASSIGNED',
  ASSIGNED = 'ASSIGNED',
  ACTIVE = 'ACTIVE',
  SCHEDULED = 'SCHEDULED',
  CANCELLED = 'CANCELLED',
  RESOLVED = 'RESOLVED',
  MODERATION_CLAIMED = 'MODERATION_CLAIMED',
  MODERATION_APPROVED = 'MODERATION_APPROVED',
}

export enum RequestTicketUrgency {
  NOT_URGENT = 'NOT_URGENT',
  ASAP = 'ASAP',
  URGENT = 'URGENT',
}

export enum ProducerStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  PREFERRED_ONLY = 'PREFERRED_ONLY',
}

export enum BrandSize {
  tiny = 'tiny',
  small = 'small',
  small_but_growing_fast = 'small_but_growing_fast',
  medium_national = 'medium_national',
  large_national = 'large_national',
  multi_national = 'multi_national',
  medium_global = 'medium_global',
  large_global = 'large_global',
  fortune_500 = 'fortune_500',
  biggest_brands_on_planet = 'biggest_brands_on_planet',
}

export enum BrandStatus {
  NORMAL = 'NORMAL',
  PREMIUM = 'PREMIUM',
  ELITE = 'ELITE',
  KEY_ACCOUNT = 'KEY_ACCOUNT',
}

export enum SubscriptionLevel {
  BASIC = 'BASIC',
  BUSINESS = 'BUSINESS',
  ENTERPRISE = 'ENTERPRISE',
}

export enum AttachmentState {
  UPLOADING = 'UPLOADING',
  SYNCING = 'SYNCING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum AttachmentType {
  CONTRACT = 'CONTRACT',
  BRIEF = 'BRIEF',
  BRAND_ASSET = 'BRAND_ASSET',
  LOGO = 'LOGO',
  INTRO_OUTRO = 'INTRO_OUTRO',
  ANIMATION = 'ANIMATION',
  GRAPHIC = 'GRAPHIC',
  THUMBNAIL = 'THUMBNAIL',
  HERO_IMAGE = 'HERO_IMAGE',
  PHOTO = 'PHOTO',
  PHOTO_FROM_VIDEO = 'PHOTO_FROM_VIDEO',
  FOOTAGE = 'FOOTAGE',
  FOOTAGE_MOBILE = 'FOOTAGE_MOBILE',
  MUSIC = 'MUSIC',
  AUDIO_TRACK = 'AUDIO_TRACK',
  DRAFT_VIDEO = 'DRAFT_VIDEO',
  FINAL_VIDEO = 'FINAL_VIDEO',
  TRANSCODED = 'TRANSCODED',
  SUMMARY = 'SUMMARY',
  WATERMARKED = 'WATERMARKED',
  OTHER = 'OTHER',
}

export enum ContentManagerAssetType {
  ANIMATION = 'ANIMATION',
  AUDIO = 'AUDIO',
  BRAND_ASSETS = 'BRAND_ASSETS',
  FOOTAGE = 'FOOTAGE',
  GRAPHIC = 'GRAPHIC',
  MUSIC = 'MUSIC',
  OTHER = 'OTHER',
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
}

export enum ContentManagerVideoState {
  DRAFT = 'DRAFT',
  FINAL = 'FINAL',
}

export enum UserState {
  CONFIRMED = 'CONFIRMED',
  UNCONFIRMED = 'UNCONFIRMED',
  LOCKED = 'LOCKED',
}

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

/* User fields that can be ordered */
export enum UserOrder {
  CREATED_AT = 'CREATED_AT',
  EMAIL = 'EMAIL',
  NAME = 'NAME',
}

/* Job fields that can used to order jobs */
export enum JobOrder {
  START_DATE = 'START_DATE',
  DUE_DATE = 'DUE_DATE',
  COMPLETED_AT = 'COMPLETED_AT',
}

export enum OpportunityState {
  PROSPECTIVE = 'PROSPECTIVE',
  IN_PROGRESS = 'IN_PROGRESS',
  CONVERTED = 'CONVERTED',
  LOST = 'LOST',
}

export enum OpportunitySourceType {
  PLATFORM = 'PLATFORM',
  SALESFORCE = 'SALESFORCE',
}

export enum OpportunityPriority {
  SAME_DAY = 'SAME_DAY',
  URGENT = 'URGENT',
  NOT_URGENT = 'NOT_URGENT',
}

export enum ProjectOrder {
  CREATED_AT = 'CREATED_AT',
  BUDGET = 'BUDGET',
  DUE_DATE = 'DUE_DATE',
  NAME = 'NAME',
  PRICE = 'PRICE',
  STATE = 'STATE',
}

export enum RequestTicketTargetType {
  GEN1_PROJECT = 'GEN1_PROJECT',
  GEN1_SHOOT = 'GEN1_SHOOT',
  GEN1_VIDEO = 'GEN1_VIDEO',
  OTHER = 'OTHER',
  VIDEO_PROJECT = 'VIDEO_PROJECT',
  WORK_CONTRACT = 'WORK_CONTRACT',
  JOB = 'JOB',
  SHOOT = 'SHOOT',
  VIDEO = 'VIDEO',
}

/* RequestTicket fields that can be ordered */
export enum RequestTicketOrder {
  CREATED_AT = 'CREATED_AT',
  URGENCY = 'URGENCY',
  SCHEDULED_FOR = 'SCHEDULED_FOR',
}

export enum FeedableType {
  ORGANISATION = 'ORGANISATION',
  HUMAN = 'HUMAN',
  PROJECT = 'PROJECT',
  VIDEO = 'VIDEO',
  SHOOT = 'SHOOT',
  JOB = 'JOB',
  WORK_CONTRACT = 'WORK_CONTRACT',
  CUSTOMER_CONTRACT = 'CUSTOMER_CONTRACT',
  CAMPAIGN = 'CAMPAIGN',
  ISSUE = 'ISSUE',
  CONTENT_CHANNEL = 'CONTENT_CHANNEL',
  CONTENT_GROUP = 'CONTENT_GROUP',
}

/* Possible types of comments */
export enum FeedCommentType {
  COMMENT = 'COMMENT',
  EMAIL = 'EMAIL',
  MEETING = 'MEETING',
  NOTE = 'NOTE',
  PHONE_CALL = 'PHONE_CALL',
  PROPOSAL = 'PROPOSAL',
}

export enum IssueState {
  NEW = 'NEW',
  IN_REVIEW = 'IN_REVIEW',
  IN_PROGRESS = 'IN_PROGRESS',
  ESCALATED = 'ESCALATED',
  RESOLVED = 'RESOLVED',
  ACCEPTED = 'ACCEPTED',
  NOT_RESOLVED = 'NOT_RESOLVED',
}

export enum StripeChargeStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
  DISPUTED = 'DISPUTED',
}

export enum CommentableType {
  REQUEST_TICKET = 'REQUEST_TICKET',
  ORGANISATION = 'ORGANISATION',
  HUMAN = 'HUMAN',
  PROJECT = 'PROJECT',
  VIDEO = 'VIDEO',
  JOB = 'JOB',
  WORK_CONTRACT = 'WORK_CONTRACT',
  CUSTOMER_CONTRACT = 'CUSTOMER_CONTRACT',
  CAMPAIGN = 'CAMPAIGN',
  SHOOT = 'SHOOT',
  ISSUE = 'ISSUE',
  CONTENT_CHANNEL = 'CONTENT_CHANNEL',
  CONTENT_GROUP = 'CONTENT_GROUP',
}

export enum EventableType {
  PROJECT = 'PROJECT',
  VIDEO = 'VIDEO',
  JOB = 'JOB',
  WORK_CONTRACT = 'WORK_CONTRACT',
  CUSTOMER_CONTRACT = 'CUSTOMER_CONTRACT',
  SHOOT = 'SHOOT',
  ISSUE = 'ISSUE',
}

export enum NotifiableType {
  REQUEST_COMMENT = 'REQUEST_COMMENT',
  FEED_ITEM = 'FEED_ITEM',
  JOB = 'JOB',
  WORK_CONTRACT = 'WORK_CONTRACT',
  WORK_CONTRACT_APPLICATION = 'WORK_CONTRACT_APPLICATION',
  WORK_CONTRACT_INVITATION = 'WORK_CONTRACT_INVITATION',
}

export enum NotificationAction {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  CANCELED = 'CANCELED',
  ASSIGNED = 'ASSIGNED',
  RESOLVED = 'RESOLVED',
  UNASSIGNED = 'UNASSIGNED',
  SKILLS_APPROVED = 'SKILLS_APPROVED',
  SKILLS_REJECTED = 'SKILLS_REJECTED',
  TICKET_COMMENT = 'TICKET_COMMENT',
  CLAIMED = 'CLAIMED',
  DUE = 'DUE',
}

export enum RequestTicketTypeName {
  CHANGE = 'CHANGE',
  TALK = 'TALK',
  UPDATE = 'UPDATE',
  OTHER = 'OTHER',
  ISSUE = 'ISSUE',
  SOMETHING_ELSE = 'SOMETHING_ELSE',
}

export enum DeviceType {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
}

/* The provider of the integration */
export enum VideoPlatformIntegrationProvider {
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO',
}

export enum OpportunityProducerRole {
  CONTENT = 'CONTENT',
  CREATIVE = 'CREATIVE',
}

/* Provider of social authentication */
export enum IdentityProvider {
  APPLE = 'APPLE',
  FACEBOOK = 'FACEBOOK',
  LINKEDIN_OAUTH2 = 'LINKEDIN_OAUTH2',
  LINKEDIN_OAUTH2_ACCESS_TOKEN = 'LINKEDIN_OAUTH2_ACCESS_TOKEN',
}

/* Possible types of approvable */
export enum ApprovableType {
  VIDEO = 'VIDEO',
  ATTACHMENT = 'ATTACHMENT',
}

export enum PreferenceState {
  PREFER = 'PREFER',
  NOT_PREFER = 'NOT_PREFER',
}

export enum SubbrandType {
  DEPARTMENT = 'DEPARTMENT',
  LOCATION = 'LOCATION',
  SUBBRAND = 'SUBBRAND',
}

/* Attachable type for Attachment */
export type Attachable =
  | Brand
  | Project
  | WorkContract
  | Video
  | ShootFootage
  | Shoot
  | CustomerContract
  | User
  | Campaign
  | ContentChannel
  | ContentGroup

export type RequestTicketAssignee = User | CreatorProfile | ProducerProfile

export type RequestTicketTarget = Project | Job | WorkContract | Shoot | Video

/* Content type for Asset */
export type Content = GCSAttachment | ExternalLink

/* Commentable types */
export type Commentable =
  | RequestTicket
  | User
  | Job
  | Brand
  | Shoot
  | Video
  | Project
  | WorkContract
  | CustomerContract
  | Campaign
  | ContentChannel
  | ContentGroup

export type RequestTicketLinkable = Job | Task

export type RequestTicketModerator = User

export type RequestTicketRequester = Gen1Bot | User

/* Feedable types */
export type Feedable =
  | User
  | Job
  | Brand
  | Shoot
  | Video
  | Project
  | WorkContract
  | CustomerContract
  | Issue
  | Campaign
  | ContentChannel
  | ContentGroup

/* FeedItem items types, could be Comment or Event */
export type FeedItemable = FeedComment | Event

/* Eventable types */
export type Eventable = Job | Shoot | Video | Project | WorkContract | CustomerContract | Issue

/* Notifiable types */
export type Notifiable =
  | Comment
  | FeedItem
  | Job
  | WorkContract
  | WorkContractApplication
  | WorkContractInvitation

export namespace LoginJwtCookie {
  export type Variables = {}

  export type Mutation = {
    __typename?: 'Mutation'
    loginJwtCookie?: LoginJwtCookie | null
  }

  export type LoginJwtCookie = {
    __typename?: 'AuthResponse'
    jwt: string
  }
}
export namespace GetProjectForPayment {
  export type Variables = {
    id: string
  }

  export type Query = {
    __typename?: 'Query'
    getProject: GetProject
  }

  export type GetProject = {
    __typename?: 'Project'
    name: string
    description?: string | null
    dueDate?: DateTime | null
    price?: Price | null
    canChargeToAccount?: boolean | null
    customerContract: CustomerContract
    location?: Location | null
    shoots?: Shoots[] | null
    videos?: Videos[] | null
    thumbnailUrl?: string | null
    product?: Product | null
  }

  export type Price = payPrice.Fragment

  export type CustomerContract = {
    __typename?: 'CustomerContract'
    brandToInvoice: BrandToInvoice
    invoices?: Invoices[] | null
  }

  export type BrandToInvoice = {
    __typename?: 'Brand'
    uuid: string
  }

  export type Invoices = {
    __typename?: 'CustomerContractInvoice'
    uuid: string
    description: string
    fullyPaid?: boolean | null
    price: _Price
    discountAmount?: DiscountAmount | null
    priceWithDiscount: PriceWithDiscount
    tax?: Tax | null
    total?: Total | null
  }

  export type _Price = payPrice.Fragment

  export type DiscountAmount = payPrice.Fragment

  export type PriceWithDiscount = payPrice.Fragment

  export type Tax = payPrice.Fragment

  export type Total = payPrice.Fragment

  export type Location = {
    __typename?: 'Location'
    city?: string | null
    country?: string | null
  }

  export type Shoots = {
    __typename?: 'Shoot'
    uuid: string
  }

  export type Videos = {
    __typename?: 'Video'
    uuid: string
  }

  export type Product = {
    __typename?: 'Product'
    image?: Image | null
  }

  export type Image = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }
}
export namespace GetAllCreditCard {
  export type Variables = {
    brandUuid?: string | null
  }

  export type Query = {
    __typename?: 'Query'
    allCreditCards?: AllCreditCards[] | null
  }

  export type AllCreditCards = {
    __typename?: 'CreditCard'
    brand: Brand
    cardBrand: string
    cardFunding: string
    createdAt: DateTime
    expiryMonth: number
    expiryYear: number
    id: string
    last4Digits: string
    owner: Owner
    permission: string
    updatedAt: DateTime
  }

  export type Brand = {
    __typename?: 'Brand'
    uuid: string
    tradingName: string
  }

  export type Owner = {
    __typename?: 'User'
    uuid: string
    name?: string | null
  }
}
export namespace AddCreditCard {
  export type Variables = {
    input: CreditCardInput
  }

  export type Mutation = {
    __typename?: 'Mutation'
    creditCard?: CreditCard | null
  }

  export type CreditCard = {
    __typename?: 'CreditCard'
    id: string
  }
}
export namespace GetCharge {
  export type Variables = {
    id: string
  }

  export type Query = {
    __typename?: 'Query'
    charge: Charge
  }

  export type Charge = {
    __typename?: 'StripeCharge'
    id: string
    status: StripeChargeStatus
    error?: string | null
  }
}
export namespace PayByCreditCard {
  export type Variables = {
    invoiceUuid: string
    cardId?: string | null
    stripeToken?: string | null
  }

  export type Mutation = {
    __typename?: 'Mutation'
    charge?: Charge | null
  }

  export type Charge = {
    __typename?: 'StripeCharge'
    id: string
    error?: string | null
    status: StripeChargeStatus
  }
}
export namespace AcceptPurchase {
  export type Variables = {
    projectId: string
    chargeToAccount?: boolean | null
  }

  export type Mutation = {
    __typename?: 'Mutation'
    customerAcceptPurchase?: CustomerAcceptPurchase | null
  }

  export type CustomerAcceptPurchase = {
    __typename?: 'SuccessResponse'
    success: boolean
  }
}
export namespace GetQuoteForm {
  export type Variables = {
    quote: QuoteInput
    videoProjectTemplateType: VideoProjectTemplateType
    trackingUuid?: string | null
  }

  export type Query = {
    __typename?: 'Query'
    getQuoteForm: GetQuoteForm
  }

  export type GetQuoteForm = {
    __typename?: 'QuoteForm'
    videoProjectTemplateType: VideoProjectTemplateType
    trackingUuid: string
    quote: Quote
    videoProjectTemplates: VideoProjectTemplates[]
    masterTimeProfilesPriced: MasterTimeProfilesPriced[]
    masterServiceQualityLevelsPriced: MasterServiceQualityLevelsPriced[]
    jobTemplatePackages: JobTemplatePackages[]
  }

  export type Quote = {
    __typename?: 'Quote'
    inspirationVideoUrls: string[]
    overview?: string | null
    shootStartAt?: DateTime | null
    projectDueAt?: DateTime | null
    title: string
    videoProjectTemplate: VideoProjectTemplate
    price: Price
    selectedMasterTimeProfile: SelectedMasterTimeProfile
    selectedMasterServiceQualityLevel: SelectedMasterServiceQualityLevel
    selectedJobTemplatePackages: SelectedJobTemplatePackages[]
  }

  export type VideoProjectTemplate = {
    __typename?: 'VideoProjectTemplate'
    slug: string
  }

  export type Price = {
    __typename?: 'Price'
    amount: number
    currency: Currency
  }

  export type Currency = {
    __typename?: 'Currency'
    code: string
    name: string
    symbol: string
    position: CurrencyPositionEnum
  }

  export type SelectedMasterTimeProfile = {
    __typename?: 'TimeProfile'
    shootHours?: number | null
    icon?: Icon | null
    name?: string | null
    slug: string
  }

  export type Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type SelectedMasterServiceQualityLevel = {
    __typename?: 'ServiceQualityLevel'
    multiplier?: number | null
    icon?: _Icon | null
    name?: string | null
    slug: string
  }

  export type _Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type SelectedJobTemplatePackages = {
    __typename?: 'QuotedJobTemplatePackage'
    index: number
    jobTemplatePackage: JobTemplatePackage
    price: _Price
    timeProfile: TimeProfile
    serviceQualityLevel: ServiceQualityLevel
  }

  export type JobTemplatePackage = {
    __typename?: 'JobTemplatePackage'
    uuid: string
    name: string
    slug: string
    serviceType?: ServiceType | null
    description: string
    icon?: __Icon | null
  }

  export type __Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type _Price = {
    __typename?: 'Price'
    amount: number
    currency: _Currency
  }

  export type _Currency = {
    __typename?: 'Currency'
    code: string
    name: string
    symbol: string
    position: CurrencyPositionEnum
  }

  export type TimeProfile = {
    __typename?: 'TimeProfile'
    shootHours?: number | null
    name?: string | null
    slug: string
  }

  export type ServiceQualityLevel = {
    __typename?: 'ServiceQualityLevel'
    name?: string | null
    slug: string
  }

  export type VideoProjectTemplates = {
    __typename?: 'VideoProjectTemplate'
    image?: Image | null
    slug: string
    name: string
    country?: Country | null
  }

  export type Image = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type Country = {
    __typename?: 'Country'
    name: string
  }

  export type MasterTimeProfilesPriced = {
    __typename?: 'TimeProfilePriced'
    price: __Price
    timeProfile: _TimeProfile
  }

  export type __Price = {
    __typename?: 'Price'
    amount: number
    currency: __Currency
  }

  export type __Currency = {
    __typename?: 'Currency'
    code: string
    name: string
    symbol: string
    position: CurrencyPositionEnum
  }

  export type _TimeProfile = {
    __typename?: 'TimeProfile'
    shootHours?: number | null
    icon?: ___Icon | null
    name?: string | null
    slug: string
  }

  export type ___Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type MasterServiceQualityLevelsPriced = {
    __typename?: 'ServiceQualityLevelPriced'
    price: ___Price
    serviceQualityLevel: _ServiceQualityLevel
  }

  export type ___Price = {
    __typename?: 'Price'
    amount: number
    currency: ___Currency
  }

  export type ___Currency = {
    __typename?: 'Currency'
    code: string
    name: string
    symbol: string
    position: CurrencyPositionEnum
  }

  export type _ServiceQualityLevel = {
    __typename?: 'ServiceQualityLevel'
    multiplier?: number | null
    icon?: ____Icon | null
    name?: string | null
    slug: string
  }

  export type ____Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type JobTemplatePackages = {
    __typename?: 'QuotedJobTemplatePackage'
    jobTemplatePackage: _JobTemplatePackage
    price: ____Price
    timeProfile: __TimeProfile
    serviceQualityLevel: __ServiceQualityLevel
  }

  export type _JobTemplatePackage = {
    __typename?: 'JobTemplatePackage'
    name: string
    slug: string
    serviceType?: ServiceType | null
    description: string
    icon?: _____Icon | null
  }

  export type _____Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type ____Price = {
    __typename?: 'Price'
    amount: number
    currency: ____Currency
  }

  export type ____Currency = {
    __typename?: 'Currency'
    code: string
    name: string
    symbol: string
    position: CurrencyPositionEnum
  }

  export type __TimeProfile = {
    __typename?: 'TimeProfile'
    shootHours?: number | null
    name?: string | null
    slug: string
  }

  export type __ServiceQualityLevel = {
    __typename?: 'ServiceQualityLevel'
    multiplier?: number | null
    name?: string | null
    slug: string
  }
}
export namespace AllCountries {
  export type Variables = {}

  export type Query = {
    __typename?: 'Query'
    allCountries: AllCountries[]
  }

  export type AllCountries = {
    __typename?: 'Country'
    uuid: string
    name: string
  }
}
export namespace FindCity {
  export type Variables = {
    countryUuid?: string | null
    query?: string | null
  }

  export type Query = {
    __typename?: 'Query'
    findCity: FindCity
  }

  export type FindCity = {
    __typename?: 'CitiesPaged'
    cities: Cities[]
  }

  export type Cities = {
    __typename?: 'City'
    uuid: string
    name: string
    default: boolean
    country: Country
  }

  export type Country = {
    __typename?: 'Country'
    uuid: string
  }
}
export namespace AllCountriesV2 {
  export type Variables = {}

  export type Query = {
    __typename?: 'Query'
    allCountries: AllCountries[]
  }

  export type AllCountries = {
    __typename?: 'Country'
    uuid: string
    name: string
  }
}
export namespace FindCityV2 {
  export type Variables = {
    countryUuid?: string | null
    query?: string | null
    pageSize?: number | null
  }

  export type Query = {
    __typename?: 'Query'
    findCity: FindCity
  }

  export type FindCity = {
    __typename?: 'CitiesPaged'
    cities: Cities[]
  }

  export type Cities = {
    __typename?: 'City'
    uuid: string
    name: string
    default: boolean
    subdivision1Name?: string | null
    country: Country
  }

  export type Country = {
    __typename?: 'Country'
    uuid: string
    name: string
  }
}
export namespace GetQuoteFormV2 {
  export type Variables = {
    quote: QuoteInput
    videoProjectTemplateType: VideoProjectTemplateType
    trackingUuid?: string | null
  }

  export type Query = {
    __typename?: 'Query'
    getQuoteForm: GetQuoteForm
  }

  export type GetQuoteForm = {
    __typename?: 'QuoteForm'
    videoProjectTemplateType: VideoProjectTemplateType
    trackingUuid: string
    quote: Quote
    videoProjectTemplates: VideoProjectTemplates[]
    masterTimeProfilesPriced: MasterTimeProfilesPriced[]
    masterServiceQualityLevelsPriced: MasterServiceQualityLevelsPriced[]
    jobTemplatePackages: JobTemplatePackages[]
  }

  export type Quote = {
    __typename?: 'Quote'
    inspirationVideoUrls: string[]
    overview?: string | null
    shootStartAt?: DateTime | null
    projectDueAt?: DateTime | null
    title: string
    videoProjectTemplate: VideoProjectTemplate
    price: Price
    selectedMasterTimeProfile: SelectedMasterTimeProfile
    selectedMasterServiceQualityLevel: SelectedMasterServiceQualityLevel
    selectedJobTemplatePackages: SelectedJobTemplatePackages[]
  }

  export type VideoProjectTemplate = {
    __typename?: 'VideoProjectTemplate'
    slug: string
  }

  export type Price = {
    __typename?: 'Price'
    amount: number
    currency: Currency
  }

  export type Currency = {
    __typename?: 'Currency'
    code: string
    name: string
    symbol: string
    position: CurrencyPositionEnum
  }

  export type SelectedMasterTimeProfile = {
    __typename?: 'TimeProfile'
    shootHours?: number | null
    icon?: Icon | null
    name?: string | null
    slug: string
  }

  export type Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type SelectedMasterServiceQualityLevel = {
    __typename?: 'ServiceQualityLevel'
    multiplier?: number | null
    icon?: _Icon | null
    name?: string | null
    slug: string
  }

  export type _Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type SelectedJobTemplatePackages = {
    __typename?: 'QuotedJobTemplatePackage'
    index: number
    jobTemplatePackage: JobTemplatePackage
    price: _Price
    timeProfile: TimeProfile
    serviceQualityLevel: ServiceQualityLevel
  }

  export type JobTemplatePackage = {
    __typename?: 'JobTemplatePackage'
    uuid: string
    name: string
    slug: string
    serviceType?: ServiceType | null
    description: string
    icon?: __Icon | null
  }

  export type __Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type _Price = {
    __typename?: 'Price'
    amount: number
    currency: _Currency
  }

  export type _Currency = {
    __typename?: 'Currency'
    code: string
    name: string
    symbol: string
    position: CurrencyPositionEnum
  }

  export type TimeProfile = {
    __typename?: 'TimeProfile'
    shootHours?: number | null
    name?: string | null
    slug: string
  }

  export type ServiceQualityLevel = {
    __typename?: 'ServiceQualityLevel'
    name?: string | null
    slug: string
  }

  export type VideoProjectTemplates = {
    __typename?: 'VideoProjectTemplate'
    image?: Image | null
    slug: string
    name: string
    country?: Country | null
  }

  export type Image = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type Country = {
    __typename?: 'Country'
    name: string
  }

  export type MasterTimeProfilesPriced = {
    __typename?: 'TimeProfilePriced'
    price: __Price
    timeProfile: _TimeProfile
  }

  export type __Price = {
    __typename?: 'Price'
    amount: number
    currency: __Currency
  }

  export type __Currency = {
    __typename?: 'Currency'
    code: string
    name: string
    symbol: string
    position: CurrencyPositionEnum
  }

  export type _TimeProfile = {
    __typename?: 'TimeProfile'
    shootHours?: number | null
    icon?: ___Icon | null
    name?: string | null
    slug: string
  }

  export type ___Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type MasterServiceQualityLevelsPriced = {
    __typename?: 'ServiceQualityLevelPriced'
    price: ___Price
    serviceQualityLevel: _ServiceQualityLevel
  }

  export type ___Price = {
    __typename?: 'Price'
    amount: number
    currency: ___Currency
  }

  export type ___Currency = {
    __typename?: 'Currency'
    code: string
    name: string
    symbol: string
    position: CurrencyPositionEnum
  }

  export type _ServiceQualityLevel = {
    __typename?: 'ServiceQualityLevel'
    multiplier?: number | null
    icon?: ____Icon | null
    name?: string | null
    slug: string
  }

  export type ____Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type JobTemplatePackages = {
    __typename?: 'QuotedJobTemplatePackage'
    jobTemplatePackage: _JobTemplatePackage
    price: ____Price
    timeProfile: __TimeProfile
    serviceQualityLevel: __ServiceQualityLevel
  }

  export type _JobTemplatePackage = {
    __typename?: 'JobTemplatePackage'
    name: string
    slug: string
    serviceType?: ServiceType | null
    description: string
    icon?: _____Icon | null
  }

  export type _____Icon = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }

  export type ____Price = {
    __typename?: 'Price'
    amount: number
    currency: ____Currency
  }

  export type ____Currency = {
    __typename?: 'Currency'
    code: string
    name: string
    symbol: string
    position: CurrencyPositionEnum
  }

  export type __TimeProfile = {
    __typename?: 'TimeProfile'
    shootHours?: number | null
    name?: string | null
    slug: string
  }

  export type __ServiceQualityLevel = {
    __typename?: 'ServiceQualityLevel'
    multiplier?: number | null
    name?: string | null
    slug: string
  }
}
export namespace AddAnalyticOrder {
  export type Variables = {
    ProjectUUID: string
    SalesChannel?: string | null
  }

  export type Mutation = {
    __typename?: 'Mutation'
    addAnalyticOrder?: AddAnalyticOrder | null
  }

  export type AddAnalyticOrder = {
    __typename?: 'SuccessResponse'
    success: boolean
  }
}
export namespace AllBrandsForPurchase {
  export type Variables = {}

  export type Query = {
    __typename?: 'Query'
    allBrandsForPurchase: AllBrandsForPurchase[]
  }

  export type AllBrandsForPurchase = {
    __typename?: 'Brand'
    avatar?: Avatar | null
    status: BrandStatus
    tradingName: string
    videoProjectsCount?: number | null
    uuid: string
    address?: string
    city?: City | null
    country?: Country | null
  }

  export type Avatar = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }
}
export namespace CreateNewProject {
  export type Variables = {
    brandUuid: string
    quote: QuoteInput
    trackingInput?: TrackingInput | null
  }

  export type Mutation = {
    __typename?: 'Mutation'
    createProject?: CreateProject | null
  }

  export type CreateProject = {
    __typename?: 'Project'
    name: string
    briefCompleted?: boolean | null
    url: string
    landingUrl?: string | null
    uuid: string
    brand?: Brand | null
  }

  export type Brand = {
    __typename?: 'Brand'
    tradingName: string
    uuid: string
  }
}
export namespace ValidateBrandDomain {
  export type Variables = {
    domain: string
  }

  export type Query = {
    __typename?: 'Query'
    validateNewBrand?: ValidateNewBrand | null
  }

  export type ValidateNewBrand = {
    __typename?: 'ValidationResponse'
    valid?: boolean | null
    errors: Errors[]
  }

  export type Errors = {
    __typename?: 'AttributeError'
    field?: string | null
    code?: string | null
    model?: string | null
  }
}
export namespace ValidateBrandName {
  export type Variables = {
    website: string
  }

  export type Query = {
    __typename?: 'Query'
    validateNewBrand?: ValidateNewBrand | null
  }

  export type ValidateNewBrand = {
    __typename?: 'ValidationResponse'
    valid?: boolean | null
    errors: Errors[]
  }

  export type Errors = {
    __typename?: 'AttributeError'
    field?: string | null
    code?: string | null
    model?: string | null
  }
}
export namespace ValidateNewUser {
  export type Variables = {
    email: string
  }

  export type Query = {
    __typename?: 'Query'
    validateNewUser?: ValidateNewUser | null
  }

  export type ValidateNewUser = {
    __typename?: 'ValidationResponse'
    valid?: boolean | null
    errors: Errors[]
  }

  export type Errors = {
    __typename?: 'AttributeError'
    field?: string | null
    code?: string | null
    model?: string | null
  }
}
export namespace ValidatePassword {
  export type Variables = {
    email: string
    password: string
  }

  export type Query = {
    __typename?: 'Query'
    validatePassword?: ValidatePassword | null
  }

  export type ValidatePassword = {
    __typename?: 'PasswordValidationResponse'
    maxPasswordLength: number
    minPasswordLength: number
    minPasswordScore: number
    passwordLength: number
    passwordScore: number
    passwordSuggestions: string[]
    passwordValid: boolean
    passwordWarning?: string | null
  }
}
export namespace AllProjectsPaginated {
  export type Variables = {
    projectStates?: ProjectState[] | null
    projectLevels?: ProjectLevel[] | null
  }

  export type Query = {
    __typename?: 'Query'
    allProjectsPaginated?: AllProjectsPaginated | null
  }

  export type AllProjectsPaginated = {
    __typename?: 'ProjectsPaged'
    projects: Projects[]
  }

  export type Projects = {
    __typename?: 'Project'
    name: string
    uuid: string
    dueDate?: DateTime | null
    shoots?: Shoot[] | null
    videos?: Video[] | null
    price?: Price | null
    projectLevel?: ProjectLevel | null
    customerContract: CustomerContract
    state: ProjectState
    thumbnailUrl?: string | null
  }

  export type Price = {
    __typename?: 'Price'
    currency: Currency
    amount: number
  }

  export type Currency = {
    __typename?: 'Currency'
    code: string
    symbol: string
  }

  export type CustomerContract = {
    __typename?: 'CustomerContract'
    signingDate?: DateTime | null
    signedAt?: DateTime | null
    projects?: Project[] | null
    invoices?: CustomerContractInvoice[] | null
  }
}
export namespace AllBrandsForPurchaseV2 {
  export type Variables = {}

  export type Query = {
    __typename?: 'Query'
    allBrandsForPurchase: AllBrandsForPurchase[]
  }

  export type AllBrandsForPurchase = {
    __typename?: 'Brand'
    avatar?: Avatar | null
    tradingName: string
    status: BrandStatus
    videoProjectsCount?: number | null
    uuid: string
  }

  export type Avatar = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }
}
export namespace GetCurrentUser {
  export type Variables = {}

  export type Query = {
    __typename?: 'Query'
    getCurrentUser: GetCurrentUser
  }

  export type GetCurrentUser = {
    __typename?: 'User'
    id: string
    name?: string | null
    phoneNumber?: string | null
    location?: Location | null
    avatar?: Avatar | null
  }

  export type Location = {
    __typename?: 'Location'
    address?: string | null
    city?: string | null
    country?: string | null
  }

  export type Avatar = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }
}
export namespace GetProductCostByLocation {
  export type Variables = {
    ID: string
    countryUUID?: string | null
    cityUUID?: string | null
  }

  export type Query = {
    __typename?: 'Query'
    calcProductCostForLocation: CalcProductCostForLocation
  }

  export type CalcProductCostForLocation = {
    __typename?: 'Price'
    amount: number
    currency: Currency
  }

  export type Currency = {
    __typename?: 'Currency'
    code: string
    denomination: number
    name: string
    position: CurrencyPositionEnum
    symbol: string
  }
}
export namespace GetVideoProduct {
  export type Variables = {
    id: string
  }

  export type Query = {
    __typename?: 'Query'
    getProduct: GetProduct
  }

  export type GetProduct = {
    __typename?: 'Product'
    uuid: string
    description: string
    name: string
    productSpecs?: JSONBlob | null
    marketingSpecs?: JSONBlob | null
    marketplaceProduct: MarketplaceProduct
    image?: Image | null
    productionSpec?: JSONBlob | null
  }

  export type MarketplaceProduct = {
    __typename?: 'MarketplaceProduct'
    uuid: string
    isActive?: boolean | null
    productMarketing?: JSONBlob | null
    productSpecs?: JSONBlob | null
    promo?: string | null
    slug: string
    averagePrice?: AveragePrice | null
  }

  export type AveragePrice = {
    __typename?: 'Price'
    amount: number
    currency: Currency
  }

  export type Currency = {
    __typename?: 'Currency'
    code: string
    name: string
    denomination: number
    symbol: string
  }

  export type Image = {
    __typename?: 'CloudinaryImage'
    cloudinaryId?: string | null
    cloudinaryType?: string | null
  }
}
export namespace GetVideo {
  export type Variables = {
    videoId: number
  }

  export type Query = {
    __typename?: 'Query'
    searchVideoById?: SearchVideoById | null
  }

  export type SearchVideoById = {
    __typename?: 'SearchableVideoResponse'
    videoIntelligenceData: VideoIntelligenceData[]
    adwordsData: AdwordsData[]
    performanceSuggestionsData: PerformanceSuggestionsData[]
    youtubeRetentionData: YoutubeRetentionData[]
    youtubeReportData: YoutubeReportData[]
  }

  export type VideoIntelligenceData = {
    __typename?: 'SearchableVideo'
    youtubeUrl?: string | null
    shots: Shots[]
    innerHits: InnerHits[]
  }

  export type Shots = {
    __typename?: 'Shot'
    startTime: number
    endTime: number
  }

  export type InnerHits = {
    __typename?: 'Entity'
    description: string
    shots: _Shots[]
  }

  export type _Shots = {
    __typename?: 'Shot'
    startTime: number
    endTime: number
  }

  export type AdwordsData = {
    __typename?: 'SearchableAdwordVideo'
    clicks?: number | null
    date?: string | null
    device?: string | null
    impressions?: number | null
    videoDurationInMiliseconds?: number | null
    videoQuartile100Rate?: number | null
    videoQuartile25Rate?: number | null
    videoQuartile50Rate?: number | null
    videoQuartile75Rate?: number | null
    videoViews?: number | null
  }

  export type PerformanceSuggestionsData = {
    __typename?: 'PerformanceSuggestion'
    action: string
    category: string
    fact: string
    score: number
  }

  export type YoutubeRetentionData = {
    __typename?: 'YoutubeRetention'
    audienceWatchRatio: number
    elapsedVideoTimeRatio: number
    relativeRetentionPerformance: number
  }

  export type YoutubeReportData = {
    __typename?: 'YoutubeReport'
    countryCode: string
    views: number
    date: string
    watchTimeMinutes: number
  }
}

export namespace payPrice {
  export type Fragment = {
    __typename?: 'Price'
    amount: number
    currency: Currency
  }

  export type Currency = {
    __typename?: 'Currency'
    code: string
    symbol: string
    position: CurrencyPositionEnum
  }
}
export enum BrandRelationship {
  Department = 'department',
  Location = 'location',
  Subbrand = 'subbrand',
}
interface ParentBrand {
  createdAt: number
  id: string
  imageUrl?: string
  name: string
  relationship: BrandRelationship
  vaasId: string
}

export interface TypesenseDocument {
  acl: string[]
  city: string
  country: string
  countryCode: string
  createdAt: number
  department: string
  id: string
  imageUrl: string
  name: string
  organisationId: string
  parent?: ParentBrand
  vaasId: string
}



// WEBPACK FOOTER //
// ./src/typings/types.ts